[
    "АБДАЛ",
    "АБЗАЦ",
    "АБОРТ",
    "АБРЕК",
    "АБРИС",
    "АБЦУГ",
    "АВАВА",
    "АВГИТ",
    "АВИЗО",
    "АВОДЬ",
    "АВОСЬ",
    "АВРАЛ",
    "АВРАН",
    "АВТОЛ",
    "АВТОР",
    "АГАВА",
    "АГАМА",
    "АГАРЬ",
    "АГГЕЛ",
    "АГЕНТ",
    "АГНЕЦ",
    "АГОНЬ",
    "АГУТИ",
    "АДАЛИ",
    "АДЕПТ",
    "АДРЕС",
    "АДРЕТ",
    "АДЫТИ",
    "АЗАРТ",
    "АЗЕТЬ",
    "АЙДАР",
    "АЙМАК",
    "АЙРАН",
    "АЙШАН",
    "АКАТЬ",
    "АКИКА",
    "АКЛЕЙ",
    "АКТЁР",
    "АКТИВ",
    "АКУЛА",
    "АКЦИЗ",
    "АКЦИЯ",
    "АЛАНЬ",
    "АЛАПА",
    "АБАИМ",
    "АБАКА",
    "АББАТ",
    "АЛАФА",
    "АЛБАН",
    "АЛЕТЬ",
    "АЛИБИ",
    "АЛКАШ",
    "АЛЛАХ",
    "АЛЛЕЯ",
    "АЛЛЮР",
    "АЛМАЗ",
    "АЛОДЬ",
    "АЛТЕЙ",
    "АЛТЫН",
    "АЛЧБА",
    "АЛЫНЬ",
    "АЛЫРА",
    "АЛЫЧА",
    "АЛЬНО",
    "АЛЬФА",
    "АМБАЛ",
    "АМБАР",
    "АМБРА",
    "АМВОН",
    "АМЁБА",
    "АМИНЬ",
    "АМПЕР",
    "АМПИР",
    "АМУРЫ",
    "АНАША",
    "АНБАР",
    "АНГЕЛ",
    "АНГИЧ",
    "АНГЛО",
    "АНЕВА",
    "АНОХА",
    "АНТАЛ",
    "АНТИК",
    "АНТРЕ",
    "АНФАС",
    "АНЧАР",
    "АОРТА",
    "АПАНА",
    "АПАЧИ",
    "АПОРТ",
    "АПЧХИ",
    "АРАБА",
    "АРАБЫ",
    "АРАВА",
    "АРАХУ",
    "АРБАН",
    "АРБУЗ",
    "АРГАЛ",
    "АРГАШ",
    "АРГИШ",
    "АРГОН",
    "АРГУН",
    "АРГУС",
    "АРДАР",
    "АРДАШ",
    "АРДЫШ",
    "АРЕВА",
    "АРЕМА",
    "АРЕНА",
    "АРЕСТ",
    "АРИНА",
    "АРКАД",
    "АРКАН",
    "АРКАР",
    "АРКУШ",
    "АРМАЙ",
    "АРМИЯ",
    "АРМУД",
    "АРМЯК",
    "АРТОС",
    "АРТЫШ",
    "АРХИВ",
    "АРЧАК",
    "АРЧУЛ",
    "АРШАН",
    "АРШИН",
    "АРЬЯН",
    "АСАУЛ",
    "АСБАР",
    "АСЕТЬ",
    "АСКЕТ",
    "АСКИТ",
    "АСОТА",
    "АСПИД",
    "АСТМА",
    "АСТРО",
    "АСЫТЬ",
    "АСЯСЬ",
    "АТАВА",
    "АТАМА",
    "АТАТА",
    "АТЛАС",
    "АТЛЕТ",
    "АТОЛЛ",
    "АТРЫШ",
    "АТЬКА",
    "АУДИО",
    "АУЛАН",
    "АУЛЫК",
    "АФЕНЯ",
    "АФЕРА",
    "АФИША",
    "АХАВА",
    "АХАТЬ",
    "АХАХА",
    "АХПИД",
    "АШАТЬ",
    "АЮКЛА",
    "АЮШКА",
    "БАБАК",
    "БАБКА",
    "БАБУК",
    "БАГАЖ",
    "БАГАН",
    "БАГЕТ",
    "БАГНО",
    "БАГОН",
    "БАГОР",
    "БАДАГ",
    "БАДАН",
    "БАДМА",
    "БАДНЯ",
    "БАДУЙ",
    "БАДЬЯ",
    "БАЖАТ",
    "БАЗАР",
    "БАЗИС",
    "БАИВА",
    "БАИТЬ",
    "БАЙКА",
    "БАЙНА",
    "БАКАЙ",
    "БАКАН",
    "БАКЕН",
    "БАКИР",
    "БАКЛА",
    "БАКЛЯ",
    "БАКСА",
    "БАКУН",
    "БАКЧА",
    "БАКША",
    "БАЛАС",
    "БАЛГА",
    "БАЛДА",
    "БАЛЕТ",
    "БАЛКА",
    "БАЛОК",
    "БАЛТА",
    "БАЛТЫ",
    "БАЛЫК",
    "БАНАН",
    "БАНДА",
    "БАНЕЦ",
    "БАНКА",
    "БАНОК",
    "БАНТА",
    "БАРАК",
    "БАРАН",
    "БАРАТ",
    "БАРАШ",
    "БАРДА",
    "БАРЕЖ",
    "БАРЖА",
    "БАРИЙ",
    "БАРИН",
    "БАРИЧ",
    "БАРКА",
    "БАРМА",
    "БАРМЫ",
    "БАРОК",
    "БАРОН",
    "БАРТЕ",
    "БАРЫШ",
    "БАСКА",
    "БАСКИ",
    "БАСМА",
    "БАСНЬ",
    "БАСНЯ",
    "БАСОК",
    "БАСОН",
    "БАСТА",
    "БАСТР",
    "БАТАС",
    "БАТАШ",
    "БАТЕР",
    "БАТИК",
    "БАТОГ",
    "БАТОН",
    "БАТУТ",
    "БАТЯН",
    "БАХТА",
    "БАХЧА",
    "БАЧАН",
    "БАЧКА",
    "БАЧКИ",
    "БАЧОК",
    "БАШКА",
    "БАШНЯ",
    "БАЯТЬ",
    "БГАТЬ",
    "БДЕТЬ",
    "БЕГОМ",
    "БЕГУН",
    "БЕДРА",
    "БЕДРО",
    "БЕЗМЕ",
    "БЕЙКА",
    "БЕКАС",
    "БЕКАХ",
    "БЕКЕТ",
    "БЕКЕШ",
    "БЕКОН",
    "БЕЛЁК",
    "БЕЛЕЦ",
    "БЕЛИЙ",
    "БЕЛИК",
    "БЕЛКА",
    "БЕЛКИ",
    "БЕЛОК",
    "БЕЛУН",
    "БЕЛЫЙ",
    "БЕЛЬЁ",
    "БЕЛЯК",
    "БЕНЗО",
    "БЕРВА",
    "БЕРДО",
    "БЕРЕГ",
    "БЕРЕТ",
    "БЕРКА",
    "БЕРМА",
    "БЕРНО",
    "БЕРЦЕ",
    "БЕСВА",
    "БЕТОН",
    "БИВАК",
    "БИВНИ",
    "БИДОН",
    "БИЗОН",
    "БИЗУН",
    "БИЗЫЙ",
    "БИКСА",
    "БИКУС",
    "БИЛЕЙ",
    "БИЛЕТ",
    "БИЛЬЕ",
    "БИЛЮН",
    "БИЛЯР",
    "БИМЬЁ",
    "БИНЕТ",
    "БИНОМ",
    "БИРЖА",
    "БИРИЧ",
    "БИРКА",
    "БИРОК",
    "БИРУН",
    "БИРЬЕ",
    "БИРЮК",
    "БИРЮЧ",
    "БИСЕР",
    "БИСТР",
    "БИТВА",
    "БИТИС",
    "БИТКИ",
    "БИТЛЗ",
    "БИТЫЙ",
    "БИТЮК",
    "БИТЮТ",
    "БИШОФ",
    "БЛАГО",
    "БЛАЖЬ",
    "БЛАЗН",
    "БЛАНК",
    "БЛЕСК",
    "БЛИНД",
    "БЛИЦЫ",
    "БЛОНА",
    "БЛОХА",
    "БЛУЗА",
    "БЛЮДО",
    "БЛЯХА",
    "БОБЁР",
    "БОБИК",
    "БОБКИ",
    "БОБЫЧ",
    "БОГАЧ",
    "БОГОТ",
    "БОГУН",
    "БОДВА",
    "БОДНЯ",
    "БОДЯК",
    "БОЖИЙ",
    "БОЖОК",
    "БОЙНЯ",
    "БОКАЛ",
    "БОКОМ",
    "БОЛДА",
    "БОЛЕЕ",
    "БОЛИД",
    "БОЛИЙ",
    "БОЛОК",
    "БОЛЮС",
    "БОЛЯН",
    "БОМБА",
    "БОМБО",
    "БОНДА",
    "БОНЗА",
    "БОНМО",
    "БОННА",
    "БОРАН",
    "БОРАЧ",
    "БОРДО",
    "БОРЕЦ",
    "БОРИФ",
    "БОРЛА",
    "БОРОВ",
    "БОРТЬ",
    "БОСКО",
    "БОСОЙ",
    "БОСТИ",
    "БОСЯК",
    "БОТВА",
    "БОТНЯ",
    "БОТОГ",
    "БОТУН",
    "БОХОН",
    "БОЧАР",
    "БОЧКА",
    "БОЯНЫ",
    "БРАВО",
    "БРАГА",
    "БРАДА",
    "БРАКИ",
    "БРАМА",
    "БРАНЫ",
    "БРАНЬ",
    "БРАСС",
    "БРАТА",
    "БРАТЬ",
    "БРАЧА",
    "БРЕМЯ",
    "БРЕШЬ",
    "БРЕЩИ",
    "БРИЛА",
    "БРИТЬ",
    "БРИЦА",
    "БРОВЬ",
    "БРОНА",
    "БРОНЕ",
    "БРОНЬ",
    "БРОНЯ",
    "БРУДИ",
    "БРУНЬ",
    "БРУСК",
    "БРЫЖИ",
    "БРЫКА",
    "БРЫЛА",
    "БРЫСЬ",
    "БРЮКИ",
    "БРЮХО",
    "БУБЕН",
    "БУБОН",
    "БУГАЙ",
    "БУГОР",
    "БУГРА",
    "БУДАН",
    "БУДЕТ",
    "БУДКА",
    "БУДНИ",
    "БУДРА",
    "БУДТО",
    "БУДЯК",
    "БУЕВО",
    "БУЖАТ",
    "БУЗУН",
    "БУЙЛА",
    "БУКВА",
    "БУКЕТ",
    "БУКИШ",
    "БУКЛЕ",
    "БУКЛИ",
    "БУКЛЯ",
    "БУКСА",
    "БУЛАТ",
    "БУЛВА",
    "БУЛГА",
    "БУЛКА",
    "БУЛЛА",
    "БУЛЬК",
    "БУРАВ",
    "БУРАК",
    "БУРАН",
    "БУРВА",
    "БУРГА",
    "БУРДА",
    "БУРКА",
    "БУРКИ",
    "БУРМА",
    "БУРСА",
    "БУРУН",
    "БУРЫЙ",
    "БУСЕЛ",
    "БУТАН",
    "БУТКА",
    "БУТОН",
    "БУТОР",
    "БУТСЫ",
    "БУТУЗ",
    "БУТУН",
    "БУТУС",
    "БУФЕР",
    "БУФЕТ",
    "БУХМА",
    "БУХТА",
    "БУШВА",
    "БУШКИ",
    "БУШМА",
    "БЫДВА",
    "БЫДЛО",
    "БЫДНЯ",
    "БЫЛИЕ",
    "БЫЛОЙ",
    "БЫЛЬЁ",
    "БЫРСЬ",
    "БЫТИЕ",
    "БЫТЬЁ",
    "БЫЧОК",
    "БЮВАР",
    "БЯНКИ",
    "ВАЙГА",
    "ВАЙДА",
    "ВАККА",
    "ВАКСА",
    "ВАЛАХ",
    "ВАЛЕЙ",
    "ВАЛЁК",
    "ВАЛЕТ",
    "ВАЛИК",
    "ВАЛКА",
    "ВАЛКИ",
    "ВАЛОК",
    "ВАЛОМ",
    "ВАЛУЙ",
    "ВАЛУН",
    "ВАЛУХ",
    "ВАЛЬЕ",
    "ВАЛЬС",
    "ВАНДА",
    "ВАНЗА",
    "ВАННА",
    "ВАНТА",
    "ВАПНА",
    "ВАПТИ",
    "ВАПУЙ",
    "ВАРАЧ",
    "ВАРВА",
    "ВАРГА",
    "ВАРИЯ",
    "ВАРКА",
    "ВАРКИ",
    "ВАРЯГ",
    "ВАСАЛ",
    "ВАТИН",
    "ВАТКА",
    "ВАФЛЯ",
    "ВАХНЯ",
    "ВАХТА",
    "ВАШКА",
    "ВАЯТЬ",
    "ВБЕЛЕ",
    "ВБИТЬ",
    "ВБРОД",
    "ВБЫЛЬ",
    "ВАГАН",
    "ВАГОН",
    "ВАДЬЯ",
    "ВАЖАН",
    "ВАЗОН",
    "ВВЕРХ",
    "ВВИДУ",
    "ВВИТЬ",
    "ВВОЛЮ",
    "ВВЫСЬ",
    "ВГЛОТ",
    "ВДАЛИ",
    "ВДАЛЬ",
    "ВДВОЕ",
    "ВДЕТЬ",
    "ВДОВА",
    "ВДОЛЬ",
    "ВДРУГ",
    "ВЕГЖА",
    "ВЕГЛА",
    "ВЕДЕТ",
    "ВЁДРО",
    "ВЕЕРО",
    "ВЕЖДА",
    "ВЕЗДЕ",
    "ВЕЗТИ",
    "ВЕЙКА",
    "ВЕКША",
    "ВЕЛЕС",
    "ВЕЛИК",
    "ВЕЛЬП",
    "ВЕЛЬС",
    "ВЕЛЮР",
    "ВЕНЕЦ",
    "ВЕНИК",
    "ВЕНОК",
    "ВЕПРЬ",
    "ВЕПСЫ",
    "ВЕРБА",
    "ВЕРЕС",
    "ВЕРЕЯ",
    "ВЕРИС",
    "ВЕРКИ",
    "ВЕРНЬ",
    "ВЕРНЯ",
    "ВЕРФЬ",
    "ВЕРША",
    "ВЕСЛО",
    "ВЕСНА",
    "ВЕСТА",
    "ВЕСТИ",
    "ВЕСТЬ",
    "ВЕТВЬ",
    "ВЕТЕР",
    "ВЕТКА",
    "ВЕТЛА",
    "ВЕТРО",
    "ВЕТРЫ",
    "ВЕЧЕР",
    "ВЕЧЕЯ",
    "ВЕЧКА",
    "ВЕЧНО",
    "ВЕЧОР",
    "ВЕШКА",
    "ВЕШНЯ",
    "ВЕЩИЙ",
    "ВЕЩУН",
    "ВЕЯТЬ",
    "ВЖАТЬ",
    "ВЖИВЕ",
    "ВЗАДИ",
    "ВЗАЕМ",
    "ВЗВАР",
    "ВЗВОД",
    "ВЗДОР",
    "ВЗДОХ",
    "ВЗЛЁТ",
    "ВЗЛЫЗ",
    "ВЗНИК",
    "ВЗНОС",
    "ВЗРЫВ",
    "ВЗЪЕМ",
    "ВЗЫТИ",
    "ВЗЯТЬ",
    "ВИБЖА",
    "ВИБРО",
    "ВИВАТ",
    "ВИГДЕ",
    "ВИДЕО",
    "ВИДКА",
    "ВИЗИР",
    "ВИЗИТ",
    "ВИЛКА",
    "ВИЛЛА",
    "ВИЛОК",
    "ВИНТО",
    "ВИОЛА",
    "ВИРАЖ",
    "ВИРУС",
    "ВИРША",
    "ВИРШИ",
    "ВИСКА",
    "ВИСКИ",
    "ВИСОК",
    "ВИТИЯ",
    "ВИТОЙ",
    "ВИТОК",
    "ВИХОР",
    "ВИХРЬ",
    "ВИШНЯ",
    "ВИЯТЬ",
    "ВКЛАД",
    "ВКОСЬ",
    "ВКРУГ",
    "ВКУПЕ",
    "ВЛАГА",
    "ВЛАГО",
    "ВЛАСЫ",
    "ВЛЕВО",
    "ВЛЕЧЬ",
    "ВЛИТЬ",
    "ВМАЛЕ",
    "ВМОЧЬ",
    "ВМЯТЬ",
    "ВНАВЕ",
    "ВНИЗУ",
    "ВНИТИ",
    "ВНОВЬ",
    "ВНОГУ",
    "ВНЯТЬ",
    "ВОБЖА",
    "ВОБЛА",
    "ВОБЧЕ",
    "ВОВЕК",
    "ВОВНЕ",
    "ВОВСЕ",
    "ВОВСЮ",
    "ВОДКА",
    "ВОДЛА",
    "ВОЕЖЕ",
    "ВОЖАК",
    "ВОЖДЬ",
    "ВОЖЖА",
    "ВОЖЖИ",
    "ВОЗКА",
    "ВОЗЛЕ",
    "ВОЗОК",
    "ВОЙЛО",
    "ВОЙНА",
    "ВОЙТИ",
    "ВОКАЛ",
    "ВОКНО",
    "ВОКША",
    "ВОЛАН",
    "ВОЛИК",
    "ВОЛИН",
    "ВОЛНА",
    "ВОЛОК",
    "ВОЛОС",
    "ВОЛОТ",
    "ВОЛУЙ",
    "ВОЛХА",
    "ВОЛХВ",
    "ВОЛЬТ",
    "ВОЛЮМ",
    "ВОМЕГ",
    "ВОПЛЬ",
    "ВОРГА",
    "ВОРОГ",
    "ВОРОК",
    "ВОРОН",
    "ВОРОП",
    "ВОРСА",
    "ВОРШТ",
    "ВОСПА",
    "ВОСЦА",
    "ВОТРА",
    "ВОТТЫ",
    "ВОТУМ",
    "ВОТЩЕ",
    "ВОХЛЫ",
    "ВОХРА",
    "ВОЧЬЮ",
    "ВОШВА",
    "ВОЩИК",
    "ВОЯКА",
    "ВПАКИ",
    "ВПИРИ",
    "ВПОРУ",
    "ВПРОК",
    "ВРАЛЬ",
    "ВРАТА",
    "ВРАТЬ",
    "ВРЕЖА",
    "ВРЕМЯ",
    "ВРЕЩИ",
    "ВРОДЕ",
    "ВРОЗЬ",
    "ВРЫТЬ",
    "ВСВАЛ",
    "ВСЕГО",
    "ВСКОК",
    "ВСКОП",
    "ВСКУП",
    "ВСКУЮ",
    "ВСЛЕД",
    "ВСЛУХ",
    "ВСОЧЬ",
    "ВСПАК",
    "ВСТОК",
    "ВСХОД",
    "ВСЮДУ",
    "ВСЯКО",
    "ВТАЛЬ",
    "ВТЕЧЬ",
    "ВТОРА",
    "ВТОРО",
    "ВТОЧЬ",
    "ВТРОЕ",
    "ВТУНЕ",
    "ВУАЛЬ",
    "ВУЙМА",
    "ВУЛАЙ",
    "ВУЛКА",
    "ВУСЕЙ",
    "ВУТОР",
    "ВУЯТЬ",
    "ВЦЕЛЕ",
    "ВЧЕРА",
    "ВЧИЛЬ",
    "ВЧУЖЕ",
    "ВШИРЬ",
    "ВШИТЬ",
    "ВЪЕЗД",
    "ВЪЯВЬ",
    "ВЫБОЙ",
    "ВЫБОР",
    "ВЫВИХ",
    "ВЫВОД",
    "ВЫВОЗ",
    "ВЫГИБ",
    "ВЫДОХ",
    "ВЫДРА",
    "ВЫЕЗД",
    "ВЫЖДА",
    "ВЫЗОВ",
    "ВЫЙТИ",
    "ВЫКУП",
    "ВЫНОС",
    "ВЫПАД",
    "ВЫПАС",
    "ВЫПОТ",
    "ВЫРАЙ",
    "ВЫРЕЗ",
    "ВЫРЕЙ",
    "ВЫРЕЦ",
    "ВЫТВА",
    "ВЫТОН",
    "ВЫТТИ",
    "ВЫХОД",
    "ВЫЧЕТ",
    "ВЫЧКА",
    "ВЫШАР",
    "ВЫШКА",
    "ВЫЯТЬ",
    "ВЬЮГА",
    "ВЬЯТЬ",
    "ВЯЛЫЙ",
    "ВЯНКИ",
    "ВЯСЛО",
    "ВЯТКА",
    "ВЯЩИЙ",
    "ГАВЕЗ",
    "ГАВКА",
    "ГАВОТ",
    "ГАГАТ",
    "ГАГРЫ",
    "ГАЗИК",
    "ГАЗНА",
    "ГАЗОН",
    "ГАИТЬ",
    "ГАЙДА",
    "ГАЙКА",
    "ГАЛЕЙ",
    "ГАЛЕК",
    "ГАЛКА",
    "ГАЛЛЫ",
    "ГАЛОП",
    "ГАЛУН",
    "ГАМАК",
    "ГАМАН",
    "ГАММА",
    "ГАНЗА",
    "ГАНКА",
    "ГАНУС",
    "ГАРАЖ",
    "ГАРВА",
    "ГАРЕМ",
    "ГАРУЗ",
    "ГАРУС",
    "ГАСИЯ",
    "ГАТВА",
    "ГАШИШ",
    "ГВАЛТ",
    "ГЕВАН",
    "ГЕЙША",
    "ГЕКТО",
    "ГЕЛИЙ",
    "ГЕЛИО",
    "ГЕЛЮН",
    "ГЕМАМ",
    "ГЕНИЙ",
    "ГЕНОМ",
    "ГЕРМО",
    "ГЕРОЙ",
    "ГЕТРЫ",
    "ГЕТТО",
    "ГЖЕЛЬ",
    "ГЗЫМЗ",
    "ГИБАР",
    "ГИГНА",
    "ГИГРО",
    "ГИДРА",
    "ГИДРО",
    "ГИЕНА",
    "ГИЛЕК",
    "ГИМГА",
    "ГИПЕР",
    "ГИПНО",
    "ГИПЮР",
    "ГИРКА",
    "ГИРЛО",
    "ГИРЧА",
    "ГИТОВ",
    "ГИЧКА",
    "ГЛАВА",
    "ГЛАВК",
    "ГЛАДЬ",
    "ГЛАЖИ",
    "ГЛАМЯ",
    "ГЛАХИ",
    "ГЛЕЙН",
    "ГЛЕНЬ",
    "ГЛЕЧА",
    "ГЛИБА",
    "ГЛИВА",
    "ГЛИКО",
    "ГЛИНА",
    "ГЛИСТ",
    "ГЛОБА",
    "ГЛОСА",
    "ГЛУБЬ",
    "ГЛУЗГ",
    "ГЛУЗД",
    "ГЛУШЬ",
    "ГЛЫБА",
    "ГЛЫЖА",
    "ГЛЯДЬ",
    "ГМАРА",
    "ГНАТЬ",
    "ГНЕЙС",
    "ГНИДА",
    "ГНИЛЬ",
    "ГНИТЬ",
    "ГНУТЬ",
    "ГОБОЙ",
    "ГОВНО",
    "ГОВОР",
    "ГОДОК",
    "ГОИТЬ",
    "ГОЛДА",
    "ГОЛЕТ",
    "ГОЛЕЦ",
    "ГОЛИК",
    "ГОЛКА",
    "ГОЛОД",
    "ГОЛОС",
    "ГОЛЫЙ",
    "ГОЛЫШ",
    "ГОЛЬЁ",
    "ГОЛЬФ",
    "ГОМАР",
    "ГОМЗА",
    "ГОМИК",
    "ГОМОН",
    "ГОНЕЦ",
    "ГОНКА",
    "ГОНОР",
    "ГОНОТ",
    "ГОПАК",
    "ГОРГА",
    "ГОРЕЦ",
    "ГОРЖА",
    "ГОРКА",
    "ГОРЛО",
    "ГОРМЯ",
    "ГОРНО",
    "ГОРОД",
    "ГОРОХ",
    "ГОРОЮ",
    "ГОРШЕ",
    "ГОРЫЧ",
    "ГОРЮН",
    "ГОСТЬ",
    "ГОТОТ",
    "ГОТЯН",
    "ГОФРЕ",
    "ГРАВЕ",
    "ГРАММ",
    "ГРАНД",
    "ГРАНТ",
    "ГРАНЬ",
    "ГРАТЬ",
    "ГРАФА",
    "ГРАЦА",
    "ГРЁЗА",
    "ГРЕЗД",
    "ГРЕКИ",
    "ГРЕТЬ",
    "ГРЕЧА",
    "ГРИБА",
    "ГРИВА",
    "ГРИПП",
    "ГРОЗА",
    "ГРОНА",
    "ГРОСС",
    "ГРУБА",
    "ГРУДА",
    "ГРУДЬ",
    "ГРУЗО",
    "ГРУНА",
    "ГРУНТ",
    "ГРУША",
    "ГРЫЖА",
    "ГРЯДА",
    "ГРЯЗЕ",
    "ГРЯЗИ",
    "ГРЯЗЬ",
    "ГУАНО",
    "ГУАШЬ",
    "ГУБКА",
    "ГУДОК",
    "ГУЖИР",
    "ГУЙКА",
    "ГУЙНА",
    "ГУЛАГ",
    "ГУЛАЙ",
    "ГУЛОМ",
    "ГУЛЬК",
    "ГУЛЬФ",
    "ГУЛЯФ",
    "ГУЛЯШ",
    "ГУММИ",
    "ГУМНО",
    "ГУМОР",
    "ГУМУС",
    "ГУНАК",
    "ГУННА",
    "ГУННЫ",
    "ГУРАН",
    "ГУРДА",
    "ГУРЕЙ",
    "ГУРИЯ",
    "ГУРОК",
    "ГУСАК",
    "ГУСАР",
    "ГУСЕК",
    "ГУСЕМ",
    "ГУСЛИ",
    "ГУСТИ",
    "ГУСТО",
    "ГУТЕЙ",
    "ГУТИН",
    "ГУЯВА",
    "ГЫБКА",
    "ГЫЧКА",
    "ГЮРЗА",
    "ДАВКА",
    "ДАВНО",
    "ДАГАН",
    "ДАДОН",
    "ДАЙГА",
    "ДАЛАК",
    "ДАЛЕЕ",
    "ДАЛИЯ",
    "ДАЛМА",
    "ДАМАН",
    "ДАМБА",
    "ДАМКА",
    "ДАРОМ",
    "ДАЦАН",
    "ДБАТЬ",
    "ДВЕРЬ",
    "ДВИЖЕ",
    "ДЕБЕТ",
    "ДЕБИЛ",
    "ДЕБИТ",
    "ДЕБОШ",
    "ДЕБРИ",
    "ДЕБРЬ",
    "ДЕБЮТ",
    "ДЕВИЗ",
    "ДЕВКА",
    "ДЕГЛО",
    "ДЕДЕР",
    "ДЕИЗМ",
    "ДЕИСТ",
    "ДЕКАН",
    "ДЕЛВА",
    "ДЕЛЁЖ",
    "ДЕЛЕЦ",
    "ДЕМОН",
    "ДЕНДИ",
    "ДЕННО",
    "ДЕРБИ",
    "ДЕРЕН",
    "ДЕРТЬ",
    "ДЕСНА",
    "ДЕСТЬ",
    "ДЕТВА",
    "ДЕТКА",
    "ДЕФИС",
    "ДЖИИН",
    "ДЖИНН",
    "ДЗЕНЬ",
    "ДЗЮДО",
    "ДИАТЕ",
    "ДИВАН",
    "ДИВИЙ",
    "ДИВЦА",
    "ДИГОЛ",
    "ДИДКА",
    "ДИЕТА",
    "ДИКИЙ",
    "ДИЛЕР",
    "ДИНАР",
    "ДИНГО",
    "ДИСКИ",
    "ДИСКО",
    "ДИТВА",
    "ДИТКА",
    "ДИЧОК",
    "ДЛАНЬ",
    "ДЛИНА",
    "ДЛИТЬ",
    "ДМИТЬ",
    "ДНИЩЕ",
    "ДОБРЕ",
    "ДОБРО",
    "ДОВОД",
    "ДОГМА",
    "ДОДОН",
    "ДОЖДЬ",
    "ДОЗГИ",
    "ДОЗДЕ",
    "ДОЗОР",
    "ДОИТЬ",
    "ДОЙТИ",
    "ДОКЕР",
    "ДОКОН",
    "ДОЛГО",
    "ДОЛОЙ",
    "ДОЛЧЕ",
    "ДОМНА",
    "ДОМОЙ",
    "ДОМРА",
    "ДОНЕЦ",
    "ДОНКА",
    "ДОНОР",
    "ДОНОС",
    "ДОНЦЕ",
    "ДОРЫН",
    "ДОСКА",
    "ДОСТО",
    "ДОСУГ",
    "ДОСЫЛ",
    "ДОСЬЕ",
    "ДОТЛА",
    "ДОХОД",
    "ДОЧЕТ",
    "ДОЧКА",
    "ДОЯТЬ",
    "ДРАГА",
    "ДРАЁК",
    "ДРАЖЕ",
    "ДРАКА",
    "ДРАЛА",
    "ДРАЛО",
    "ДРАМА",
    "ДРАТЬ",
    "ДРЕБА",
    "ДРЕВО",
    "ДРЕГА",
    "ДРЕЙФ",
    "ДРЕЛЬ",
    "ДРЁМА",
    "ДРИЛЬ",
    "ДРИФТ",
    "ДРОБА",
    "ДРОБЬ",
    "ДРОВА",
    "ДРОГА",
    "ДРОГИ",
    "ДРОЖЬ",
    "ДРОЗД",
    "ДРОФА",
    "ДРУЗА",
    "ДРУЗГ",
    "ДРЯБЫ",
    "ДРЯЗГ",
    "ДРЯНЬ",
    "ДУБАС",
    "ДУБЛЬ",
    "ДУБЬЁ",
    "ДУВАН",
    "ДУДАК",
    "ДУДКА",
    "ДУДКИ",
    "ДУЖИЙ",
    "ДУЖКА",
    "ДУКАТ",
    "ДУЛЕБ",
    "ДУЛМА",
    "ДУМКА",
    "ДУНАН",
    "ДУНСТ",
    "ДУПЛЁ",
    "ДУПЛО",
    "ДУРАК",
    "ДУРЕЙ",
    "ДУРИЙ",
    "ДУРНО",
    "ДУТЫЙ",
    "ДУТЬЁ",
    "ДУХАН",
    "ДУХОМ",
    "ДУЧКА",
    "ДУШКА",
    "ДУШОК",
    "ДУЭЛЬ",
    "ДЩЕРЬ",
    "ДЫБОМ",
    "ДЫГЫЛ",
    "ДЫДОР",
    "ДЫЛДА",
    "ДЫМКА",
    "ДЫМОК",
    "ДЫРКА",
    "ДЫРСА",
    "ДЫШЛО",
    "ДЮЖИЙ",
    "ДЮМОК",
    "ДЮШЕС",
    "ДЯТЕЛ",
    "ЕЙНЫЙ",
    "ЕТМАН",
    "ЕЛБАН",
    "ЕЗУИТ",
    "ЕГОЗА",
    "ЕЗДКА",
    "ЕЛЕНЬ",
    "ЕЖЕЛИ",
    "ЁРНИК",
    "ЁМКИЙ",
    "ЖАБРА",
    "ЖАБРЫ",
    "ЖАГРА",
    "ЖАЖДА",
    "ЖАКАН",
    "ЖАКЕТ",
    "ЖАЛКО",
    "ЖАЛОН",
    "ЖАРОК",
    "ЖАТВА",
    "ЖАТКА",
    "ЖБЕНЬ",
    "ЖВАЛА",
    "ЖГОДА",
    "ЖДАТЬ",
    "ЖЕЛВЬ",
    "ЖЕЛДЬ",
    "ЖЕЛНА",
    "ЖЕЛОБ",
    "ЖЁЛЧЬ",
    "ЖЕМОК",
    "ЖЕНИХ",
    "ЖЕРВА",
    "ЖЕРДЬ",
    "ЖЕРЕХ",
    "ЖЕРЛО",
    "ЖЕСКА",
    "ЖЕСТЬ",
    "ЖЕТОН",
    "ЖИБЕЦ",
    "ЖИВЕЦ",
    "ЖИВМЯ",
    "ЖИВОЙ",
    "ЖИВОТ",
    "ЖИДКО",
    "ЖИЖКА",
    "ЖИЗНЕ",
    "ЖИЗНЬ",
    "ЖИЛЕТ",
    "ЖИЛЕЦ",
    "ЖИЛОЙ",
    "ЖИЛЬЁ",
    "ЖИРАФ",
    "ЖИРИМ",
    "ЖИТИЕ",
    "ЖИТЬЁ",
    "ЖИШКА",
    "ЖЛУДИ",
    "ЖМУТЬ",
    "ЖНИЦА",
    "ЖОКЕЙ",
    "ЖОЛВЬ",
    "ЖОЛНА",
    "ЖОНКА",
    "ЖРАТЬ",
    "ЖУЛАН",
    "ЖУЛИК",
    "ЖУПАН",
    "ЖУПЕЛ",
    "ЖУРИН",
    "ЖУЧКА",
    "ЖУЧОК",
    "ЗАБЕГ",
    "ЗАБОЙ",
    "ЗАБОР",
    "ЗАВАЛ",
    "ЗАВИЯ",
    "ЗАВОД",
    "ЗАВОЙ",
    "ЗАВОР",
    "ЗАВСЕ",
    "ЗАВУЧ",
    "ЗАВХО",
    "ЗАГАР",
    "ЗАГИБ",
    "ЗАГОН",
    "ЗАГОТ",
    "ЗАДЕВ",
    "ЗАДЕЛ",
    "ЗАДНЕ",
    "ЗАДОК",
    "ЗАДОМ",
    "ЗАДОР",
    "ЗАЕЗД",
    "ЗАЖИМ",
    "ЗАЖОР",
    "ЗАЗОР",
    "ЗАИКА",
    "ЗАЙКА",
    "ЗАЙТИ",
    "ЗАКАЛ",
    "ЗАКАТ",
    "ЗАКОЛ",
    "ЗАКОН",
    "ЗАКОП",
    "ЗАКУТ",
    "ЗАКЯТ",
    "ЗАЛИВ",
    "ЗАЛОГ",
    "ЗАЛОЙ",
    "ЗАЛОМ",
    "ЗАМАЙ",
    "ЗАМОК",
    "ЗАМОР",
    "ЗАМУЖ",
    "ЗАМША",
    "ЗАНОС",
    "ЗАПАД",
    "ЗАПАЛ",
    "ЗАПАХ",
    "ЗАПЕВ",
    "ЗАПОЙ",
    "ЗАПОР",
    "ЗАРАЗ",
    "ЗАРОД",
    "ЗАРОК",
    "ЗАРЯД",
    "ЗАСПА",
    "ЗАТЕМ",
    "ЗАТЕЯ",
    "ЗАТИН",
    "ЗАТМА",
    "ЗАТОК",
    "ЗАТОН",
    "ЗАТОР",
    "ЗАУЗА",
    "ЗАУМЬ",
    "ЗАХАБ",
    "ЗАХОД",
    "ЗАЧЕМ",
    "ЗАЧЁС",
    "ЗАЧЁТ",
    "ЗАЧИН",
    "ЗАЩИМ",
    "ЗБРАН",
    "ЗБРУН",
    "ЗБРУЯ",
    "ЗВАРЬ",
    "ЗВАТЬ",
    "ЗВЕНО",
    "ЗВЕРО",
    "ЗВЕРЬ",
    "ЗВУКО",
    "ЗДЕСЬ",
    "ЗДОБА",
    "ЗДРАВ",
    "ЗЕБРА",
    "ЗЕБРИ",
    "ЗЕВОК",
    "ЗЕЛВЬ",
    "ЗЕЛИЕ",
    "ЗЕЛЬЕ",
    "ЗЕМЕЦ",
    "ЗЕМЛЕ",
    "ЗЕМЛЯ",
    "ЗЕМНО",
    "ЗЕНИТ",
    "ЗЕНКО",
    "ЗЕРЕН",
    "ЗЕРНО",
    "ЗЕТИН",
    "ЗЕФИР",
    "ЗЕЯТЬ",
    "ЗИЛАН",
    "ЗИМОЙ",
    "ЗИМОК",
    "ЗИПУН",
    "ЗИТИН",
    "ЗИЯТЬ",
    "ЗЛАТО",
    "ЗЛЕТЬ",
    "ЗЛИТЬ",
    "ЗЛОБА",
    "ЗЛЮКА",
    "ЗНАМЯ",
    "ЗНАТЬ",
    "ЗОКОР",
    "ЗОЛОК",
    "ЗОРОД",
    "ЗОТКА",
    "ЗРАЗЫ",
    "ЗРЕТЬ",
    "ЗРЫДЬ",
    "ЗУБЕЦ",
    "ЗУБОК",
    "ЗУВЕЙ",
    "ЗУГОЛ",
    "ЗУГРА",
    "ЗУРНА",
    "ЗУРОД",
    "ЗЫБКА",
    "ЗЫБУН",
    "ЗЫМЗА",
    "ЗЯБЕР",
    "ЗЯБРА",
    "ЗЯРЫК",
    "ИВАСИ",
    "ИВЕНЬ",
    "ИВНЯК",
    "ИВРИТ",
    "ИВУЛЬ",
    "ИГОТЬ",
    "ИГРЕК",
    "ИГРЕЦ",
    "ИГРОК",
    "ИГРУН",
    "ИДЕАЛ",
    "ИДИОТ",
    "ИЕРЕЙ",
    "ИЖИЦА",
    "ИЗБАЧ",
    "ИЗВЕЙ",
    "ИЗВЕС",
    "ИЗВЕТ",
    "ИЗВИВ",
    "ИЗВНЕ",
    "ИЗВОД",
    "ИЗВОЙ",
    "ИЗВОН",
    "ИЗГИБ",
    "ИЗГОЙ",
    "ИЗДОЛ",
    "ИЗДОР",
    "ИЗЖИЛ",
    "ИЗЗОЛ",
    "ИЗЛЁТ",
    "ИЗЛОГ",
    "ИЗЛОМ",
    "ИЗМОЛ",
    "ИЗМОР",
    "ИЗНОЙ",
    "ИЗОТЬ",
    "ИЗЪЕМ",
    "ИЗЪЯН",
    "ИЗЫСК",
    "ИЗЮБР",
    "ИКАТЬ",
    "ИКОНА",
    "ИКОНЯ",
    "ИКОТА",
    "ИКРЮК",
    "ИКУША",
    "ИЛЬКА",
    "ИЛЬНО",
    "ИМАТЬ",
    "ИМЕНЬ",
    "ИМЕТЬ",
    "ИМИДЖ",
    "ИМПЕТ",
    "ИМРЕК",
    "ИНАКО",
    "ИНАЧЕ",
    "ИНГОД",
    "ИНДУС",
    "ИНДЮК",
    "ИНЕТЬ",
    "ИНЖИР",
    "ИНМАР",
    "ИНТЕР",
    "ИНУДА",
    "ИНШИЙ",
    "ИОДНА",
    "ИПАРХ",
    "ИПРИТ",
    "ИРБИС",
    "ИРЕНЬ",
    "ИРИНА",
    "ИРИЦА",
    "ИРМОС",
    "ИРХАЮ",
    "ИСКРА",
    "ИСКУС",
    "ИСЛАМ",
    "ИСЛОН",
    "ИСПОД",
    "ИСПУГ",
    "ИССОП",
    "ИСТЕЦ",
    "ИСТКА",
    "ИСТЛА",
    "ИСТОД",
    "ИСТОК",
    "ИСТОР",
    "ИСТЫЙ",
    "ИСХОД",
    "ИТАЛО",
    "ИТОГО",
    "ИТРИЙ",
    "ИУДЕИ",
    "ИФИКА",
    "ИХНИЙ",
    "ИХТИО",
    "ИШИАС",
    "ИШИМЫ",
    "ИЩАУЛ",
    "КАБАВ",
    "КАБАК",
    "КАБАН",
    "КАБЗА",
    "КАВАШ",
    "КАВЕТ",
    "КАВКА",
    "КАВУН",
    "КАВЫШ",
    "КАГАЛ",
    "КАГЛА",
    "КАДЕТ",
    "КАДКА",
    "КАДОЛ",
    "КАДРА",
    "КАДРЫ",
    "КАДУК",
    "КАДЫК",
    "КАЖДО",
    "КАЗАК",
    "КАЗАН",
    "КАЗЕЙ",
    "КАЗКА",
    "КАЗНА",
    "КАЗНЬ",
    "КАЗУС",
    "КАЗЮК",
    "КАИТЬ",
    "КАЙКА",
    "КАЙЛА",
    "КАЙЛО",
    "КАЙМА",
    "КАЙРА",
    "КАКАО",
    "КАКОЙ",
    "КАКУР",
    "КАКША",
    "КАЛАН",
    "КАЛАЧ",
    "КАЛБА",
    "КАЛГА",
    "КАЛДА",
    "КАЛДЫ",
    "КАЛИЙ",
    "КАЛИФ",
    "КАЛИЧ",
    "КАЛТИ",
    "КАЛЫК",
    "КАЛЫМ",
    "КАЛЬЯ",
    "КАМАС",
    "КАМЕЙ",
    "КАМЕЯ",
    "КАМИК",
    "КАМИН",
    "КАМКА",
    "КАМНЕ",
    "КАМСА",
    "КАМЧА",
    "КАМЫС",
    "КАМЫШ",
    "КАМЬЯ",
    "КАНАТ",
    "КАНВА",
    "КАНКА",
    "КАНОБ",
    "КАНОН",
    "КАНОЭ",
    "КАНТА",
    "КАНУН",
    "КАНЧА",
    "КАНЮК",
    "КАПАН",
    "КАПЕР",
    "КАПИК",
    "КАПЛЯ",
    "КАПОК",
    "КАПОР",
    "КАПОТ",
    "КАПРИ",
    "КАПСЯ",
    "КАПУТ",
    "КАПЦЫ",
    "КАРАТ",
    "КАРГА",
    "КАРДА",
    "КАРЕК",
    "КАРИЙ",
    "КАРЛА",
    "КАРНА",
    "КАРНИ",
    "КАРСТ",
    "КАРТА",
    "КАРЧА",
    "КАРЫМ",
    "КАРЫШ",
    "КАСИЯ",
    "КАСКА",
    "КАСЛО",
    "КАССА",
    "КАСТА",
    "КАСТЬ",
    "КАСУБ",
    "КАТАР",
    "КАТЕР",
    "КАТЕТ",
    "КАТОД",
    "КАТОК",
    "КАТУХ",
    "КАТЦА",
    "КАТЫК",
    "КАТЫШ",
    "КАФЛЯ",
    "КАЦАП",
    "КАЧАН",
    "КАЧИМ",
    "КАЧКА",
    "КАЧУР",
    "КАШИК",
    "КАШКА",
    "КАШНЕ",
    "КАШПО",
    "КАЩЕЙ",
    "КАЮКА",
    "КАЮРА",
    "КАЮТА",
    "КАЯТЬ",
    "КВАГА",
    "КВАЗИ",
    "КВАНТ",
    "КВАРЦ",
    "КВОТА",
    "КЕБАВ",
    "КЕВЬЕ",
    "КЕГЛИ",
    "КЕГЛЯ",
    "КЕКОС",
    "КЕКУР",
    "КЕЛЕП",
    "КЕЛИМ",
    "КЕЛОК",
    "КЕЛЬЯ",
    "КЕЛЮХ",
    "КЕНАФ",
    "КЕНГА",
    "КЕНДА",
    "КЕПКА",
    "КЕРЕЗ",
    "КЕРЦА",
    "КЕРШИ",
    "КЕСОС",
    "КЕФИР",
    "КЗАДИ",
    "КИБАС",
    "КИБКА",
    "КИВЕР",
    "КИВОК",
    "КИВЦА",
    "КИЖМА",
    "КИЗЕК",
    "КИЗИЛ",
    "КИЗЯК",
    "КИЛКИ",
    "КИЛЯК",
    "КИНЗА",
    "КИОСК",
    "КИПЕР",
    "КИПКА",
    "КИПОР",
    "КИРАС",
    "КИРЕЯ",
    "КИРЗА",
    "КИРКА",
    "КИРПЬ",
    "КИСЕТ",
    "КИСЕЯ",
    "КИСКА",
    "КИСТА",
    "КИСТЬ",
    "КИТЕЦ",
    "КИЧИМ",
    "КИЧКА",
    "КИЧКО",
    "КИШКА",
    "КИШМЯ",
    "КИЮРА",
    "КЛАДЬ",
    "КЛАКА",
    "КЛАСС",
    "КЛЕРК",
    "КЛЁСТ",
    "КЛЕТЬ",
    "КЛЕЧЬ",
    "КЛЕШИ",
    "КЛИКА",
    "КЛИПЫ",
    "КЛИШЕ",
    "КЛОУН",
    "КЛУНЯ",
    "КЛУША",
    "КЛЫГА",
    "КЛЮКА",
    "КЛЮФТ",
    "КЛЮША",
    "КЛЯГА",
    "КЛЯМС",
    "КЛЯЧА",
    "КМЕТЬ",
    "КМОТР",
    "КНЕХТ",
    "КНИГА",
    "КНИГО",
    "КНИЗУ",
    "КНИТА",
    "КНИЦА",
    "КНЯЗЬ",
    "КОБЕЦ",
    "КОБЗА",
    "КОБЛО",
    "КОБРА",
    "КОВЁР",
    "КОВКА",
    "КОГВА",
    "КОГДА",
    "КОГМА",
    "КОДАШ",
    "КОЖАН",
    "КОЖУХ",
    "КОЗАК",
    "КОЗЁЛ",
    "КОЗЛО",
    "КОЗЛЫ",
    "КОЗНИ",
    "КОЗНЬ",
    "КОЙГА",
    "КОЙДЫ",
    "КОЙКА",
    "КОЙМА",
    "КОЙОТ",
    "КОККИ",
    "КОКОН",
    "КОКОС",
    "КОКУЙ",
    "КОКУР",
    "КОКША",
    "КОЛБА",
    "КОЛДЫ",
    "КОЛЕР",
    "КОЛЕТ",
    "КОЛЕЯ",
    "КОЛИТ",
    "КОЛКА",
    "КОЛЛИ",
    "КОЛОБ",
    "КОЛОК",
    "КОЛОС",
    "КОЛПА",
    "КОЛПЬ",
    "КОЛУН",
    "КОЛХО",
    "КОЛЧА",
    "КОЛЫМ",
    "КОЛЬЕ",
    "КОЛЬТ",
    "КОЛЮР",
    "КОЛЮХ",
    "КОМАР",
    "КОМБИ",
    "КОМЕН",
    "КОМИК",
    "КОМКА",
    "КОМОД",
    "КОНАК",
    "КОНГА",
    "КОНДА",
    "КОНЁК",
    "КОНЕЦ",
    "КОНИК",
    "КОННО",
    "КОНОБ",
    "КОНТР",
    "КОНУС",
    "КОНЮХ",
    "КОПАЙ",
    "КОПАЛ",
    "КОПЕЖ",
    "КОПЁР",
    "КОПЕЦ",
    "КОПИЯ",
    "КОПКА",
    "КОПНА",
    "КОПУН",
    "КОПЦЫ",
    "КОПЫЛ",
    "КОПЫС",
    "КОПЬЁ",
    "КОРАЛ",
    "КОРАН",
    "КОРБА",
    "КОРГА",
    "КОРДА",
    "КОРЕЦ",
    "КОРЕШ",
    "КОРКА",
    "КОРМА",
    "КОРМО",
    "КОРНА",
    "КОРОБ",
    "КОРОП",
    "КОРСА",
    "КОРЧА",
    "КОРЧИ",
    "КОРЬЁ",
    "КОРЯК",
    "КОСЕЦ",
    "КОСМА",
    "КОСМО",
    "КОСМЫ",
    "КОСОЙ",
    "КОСТЬ",
    "КОСЯК",
    "КОТАР",
    "КОТВА",
    "КОТЁЛ",
    "КОТЕР",
    "КОТИК",
    "КОТОМ",
    "КОТУХ",
    "КОТЦЫ",
    "КОТЮР",
    "КОТЯК",
    "КОФТА",
    "КОХРА",
    "КОЧАН",
    "КОЧЕТ",
    "КОЧКА",
    "КОШАК",
    "КОШВЫ",
    "КОШИК",
    "КОШКА",
    "КОШМА",
    "КОШПА",
    "КОШУК",
    "КОЩЕЙ",
    "КРАГИ",
    "КРАЖА",
    "КРАЛЬ",
    "КРАЛЯ",
    "КРАНЦ",
    "КРАСА",
    "КРАТА",
    "КРАШЕ",
    "КРЕДО",
    "КРЕЖА",
    "КРЕКТ",
    "КРЕОЛ",
    "КРЕПЬ",
    "КРЕСС",
    "КРЕСТ",
    "КРЕЦА",
    "КРИВО",
    "КРИГА",
    "КРИЛЬ",
    "КРИЦА",
    "КРОВЕ",
    "КРОВО",
    "КРОВЬ",
    "КРОКА",
    "КРОКИ",
    "КРОЛЬ",
    "КРОНА",
    "КРОНЫ",
    "КРОСС",
    "КРОХА",
    "КРУПА",
    "КРУЧА",
    "КРЫГА",
    "КРЫЛО",
    "КРЫСА",
    "КРЫТЬ",
    "КРЫША",
    "КРЮКИ",
    "КРЯДУ",
    "КСЕНЬ",
    "КТОМУ",
    "КТЫРЬ",
    "КУБАН",
    "КУБАС",
    "КУБИК",
    "КУБЛО",
    "КУБОК",
    "КУБРА",
    "КУБЫС",
    "КУГЛЬ",
    "КУДЛО",
    "КУДРА",
    "КУДРИ",
    "КУДУК",
    "КУЕНЬ",
    "КУЗЕН",
    "КУЗЛО",
    "КУЗНЯ",
    "КУЗОВ",
    "КУЙТА",
    "КУКАН",
    "КУКИШ",
    "КУКЛА",
    "КУКСА",
    "КУКТА",
    "КУКУЯ",
    "КУКША",
    "КУЛАЙ",
    "КУЛАК",
    "КУЛАН",
    "КУЛАС",
    "КУЛЁК",
    "КУЛЕШ",
    "КУЛИК",
    "КУЛИЧ",
    "КУЛИШ",
    "КУЛОН",
    "КУЛЫН",
    "КУЛЬТ",
    "КУЛЯШ",
    "КУМАК",
    "КУМАЧ",
    "КУМЖА",
    "КУМИР",
    "КУМКА",
    "КУМКИ",
    "КУМЫС",
    "КУНАК",
    "КУНЖА",
    "КУНКА",
    "КУНЦА",
    "КУПЕР",
    "КУПЕЦ",
    "КУПЛЯ",
    "КУПОЛ",
    "КУПОН",
    "КУРАЖ",
    "КУРАЙ",
    "КУРАН",
    "КУРДУ",
    "КУРДЫ",
    "КУРЕЯ",
    "КУРИК",
    "КУРИМ",
    "КУРИЯ",
    "КУРМА",
    "КУРНА",
    "КУРОК",
    "КУРПЫ",
    "КУРПЯ",
    "КУРСЫ",
    "КУРТА",
    "КУРУЛ",
    "КУРУН",
    "КУРЦЫ",
    "КУРЬЯ",
    "КУСОК",
    "КУТАК",
    "КУТАС",
    "КУТЁЖ",
    "КУТЕМ",
    "КУТЕР",
    "КУТИЯ",
    "КУТНЯ",
    "КУТОК",
    "КУТРА",
    "КУТУЗ",
    "КУТУМ",
    "КУТЬЯ",
    "КУФТА",
    "КУХВА",
    "КУХНЯ",
    "КУХТА",
    "КУЦАН",
    "КУЦЫЙ",
    "КУЧЕР",
    "КУЧМА",
    "КУШАК",
    "КУШИР",
    "КУШКА",
    "КУШУР",
    "КУЯВА",
    "КЫЧАН",
    "КЫЧИМ",
    "КЫЧТА",
    "КЮВЕТ",
    "ЛАБАЗ",
    "ЛАБЕЦ",
    "ЛАВАШ",
    "ЛАВДА",
    "ЛАВКА",
    "ЛАВРА",
    "ЛАВРУ",
    "ЛАДАН",
    "ЛАДЬЯ",
    "ЛАЖЕК",
    "ЛАЗЕР",
    "ЛАЙБА",
    "ЛАЙДА",
    "ЛАЙКА",
    "ЛАКЕЙ",
    "ЛАМБА",
    "ЛАМПА",
    "ЛАНЬЯ",
    "ЛАПАС",
    "ЛАПКА",
    "ЛАПТА",
    "ЛАПША",
    "ЛАРГО",
    "ЛАРЁК",
    "ЛАРЕЦ",
    "ЛАРИЧ",
    "ЛАСКА",
    "ЛАССО",
    "ЛАСТА",
    "ЛАСУН",
    "ЛАСЫЙ",
    "ЛАТКА",
    "ЛАТУК",
    "ЛАФЕТ",
    "ЛАФИТ",
    "ЛАХМЫ",
    "ЛАХОН",
    "ЛАХТА",
    "ЛАЧКА",
    "ЛАЯТЬ",
    "ЛБИНА",
    "ЛГАТЬ",
    "ЛЕВША",
    "ЛЕВЫЙ",
    "ЛЕГАТ",
    "ЛЕДВА",
    "ЛЕЖАК",
    "ЛЁЖКА",
    "ЛЕЖМЯ",
    "ЛЕЗГА",
    "ЛЕЗТЬ",
    "ЛЕЙКА",
    "ЛЕЙКО",
    "ЛЕЛЕК",
    "ЛЕМЕХ",
    "ЛЕММА",
    "ЛЕМУР",
    "ЛЕНГА",
    "ЛЕНОК",
    "ЛЕНТА",
    "ЛЕНТО",
    "ЛЕНЦА",
    "ЛЕПЕТ",
    "ЛЕПКА",
    "ЛЕПТА",
    "ЛЕПЫЙ",
    "ЛЕСКА",
    "ЛЕСТЬ",
    "ЛЕСХО",
    "ЛЁТКА",
    "ЛЕТОК",
    "ЛЕТОМ",
    "ЛЕТУН",
    "ЛЕФЕР",
    "ЛЕШАК",
    "ЛЕШИЙ",
    "ЛЖИЦА",
    "ЛИАНА",
    "ЛИВАН",
    "ЛИВЕР",
    "ЛИВМЯ",
    "ЛИДЕР",
    "ЛИКБЕ",
    "ЛИКЁР",
    "ЛИЛЕЯ",
    "ЛИЛИЯ",
    "ЛИЛОК",
    "ЛИМАН",
    "ЛИМИТ",
    "ЛИМОК",
    "ЛИМОН",
    "ЛИМФА",
    "ЛИНЁК",
    "ЛИНЗА",
    "ЛИНИЯ",
    "ЛИПТЫ",
    "ЛИРИК",
    "ЛИТЕР",
    "ЛИТЕЦ",
    "ЛИТИЯ",
    "ЛИТОЙ",
    "ЛИТРА",
    "ЛИТЬЁ",
    "ЛИФТА",
    "ЛИХАЧ",
    "ЛИХВА",
    "ЛИХОЙ",
    "ЛИЦЕЙ",
    "ЛИЧМА",
    "ЛИШАЙ",
    "ЛИШЕК",
    "ЛИЯЛО",
    "ЛИЯТЬ",
    "ЛОБАЗ",
    "ЛОБАН",
    "ЛОББИ",
    "ЛОБОК",
    "ЛОБЬЕ",
    "ЛОВЕЦ",
    "ЛОВЛЯ",
    "ЛОДИЯ",
    "ЛОДКА",
    "ЛОДОГ",
    "ЛОДЬЯ",
    "ЛОЖКА",
    "ЛОЖНО",
    "ЛОЖНЯ",
    "ЛОЖОК",
    "ЛОИНА",
    "ЛОКОН",
    "ЛОМКА",
    "ЛОПАС",
    "ЛОПТА",
    "ЛОПУХ",
    "ЛОСЯК",
    "ЛОТВА",
    "ЛОТИЯ",
    "ЛОТОК",
    "ЛОТОС",
    "ЛОУХА",
    "ЛОХМА",
    "ЛОХМЬ",
    "ЛОХТА",
    "ЛОЦИЯ",
    "ЛОЧАК",
    "ЛОШАК",
    "ЛОШИЙ",
    "ЛУБОК",
    "ЛУЖОК",
    "ЛУЗАН",
    "ЛУЗГА",
    "ЛУЗИК",
    "ЛУКАН",
    "ЛУКАС",
    "ЛУКНО",
    "ЛУМКА",
    "ЛУНЕК",
    "ЛУНКА",
    "ЛУПАЧ",
    "ЛУПИН",
    "ЛУТОК",
    "ЛУХТА",
    "ЛУЧОК",
    "ЛУЧШЕ",
    "ЛЫЖНЯ",
    "ЛЫЗЛА",
    "ЛЫСЫЙ",
    "ЛЫЧКИ",
    "ЛЫЧКО",
    "ЛЬЯЛО",
    "ЛЮБОЙ",
    "ЛЮГЕР",
    "ЛЮДИН",
    "ЛЮКША",
    "ЛЮНЕТ",
    "ЛЮПИН",
    "ЛЮПТЫ",
    "ЛЮТИК",
    "ЛЮТНЯ",
    "ЛЮТЫЙ",
    "ЛЮШНЯ",
    "ЛЯЖКА",
    "ЛЯЗЫК",
    "ЛЯКИЙ",
    "ЛЯКША",
    "ЛЯМЕЦ",
    "ЛЯМЕШ",
    "ЛЯМКА",
    "ЛЯПИС",
    "ЛЯШКА",
    "МАВРЫ",
    "МАГИЯ",
    "МАГМА",
    "МАГЫТ",
    "МАДАМ",
    "МАДЕЖ",
    "МАЕТА",
    "МАЖОР",
    "МАЗНЯ",
    "МАЗОК",
    "МАЗУТ",
    "МАЙЕР",
    "МАЙКА",
    "МАЙКО",
    "МАЙНА",
    "МАЙОР",
    "МАКАР",
    "МАКЕТ",
    "МАКЕШ",
    "МАКРО",
    "МАКСА",
    "МАКСИ",
    "МАЛАЙ",
    "МАЛЁК",
    "МАЛЕЦ",
    "МАЛИК",
    "МАЛИТ",
    "МАЛИЧ",
    "МАЛКА",
    "МАЛЫЙ",
    "МАЛЫШ",
    "МАЛЬЕ",
    "МАЛЯР",
    "МАНЕЖ",
    "МАНЕР",
    "МАНИЕ",
    "МАНИЯ",
    "МАННА",
    "МАНСИ",
    "МАНТО",
    "МАНТУ",
    "МАРАЛ",
    "МАРИК",
    "МАРКА",
    "МАРКИ",
    "МАРЛИ",
    "МАРЛЯ",
    "МАРЬЯ",
    "МАСАК",
    "МАСКА",
    "МАСЛО",
    "МАСОН",
    "МАССА",
    "МАСТЬ",
    "МАТЕЖ",
    "МАТКА",
    "МАТОР",
    "МАФИЯ",
    "МАХАН",
    "МАХРА",
    "МАХРЫ",
    "МАЧТА",
    "МАШАЛ",
    "МАШОК",
    "МАЯТЬ",
    "МГАЛО",
    "МЕДИК",
    "МЕДИО",
    "МЕДЯК",
    "МЕЕВА",
    "МЕЕВО",
    "МЕЖДУ",
    "МЕЗГА",
    "МЕКАН",
    "МЕЛДА",
    "МЕЛИК",
    "МЕЛКО",
    "МЕЛОК",
    "МЕЛЮС",
    "МЕНЕК",
    "МЕРДА",
    "МЕРЕН",
    "МЕРИН",
    "МЕСТИ",
    "МЕСТО",
    "МЕСТЬ",
    "МЕСЯЦ",
    "МЕТЕО",
    "МЕТИК",
    "МЕТИЛ",
    "МЕТИС",
    "МЕТКА",
    "МЕТЛА",
    "МЕТОД",
    "МЕТРО",
    "МЕЧКА",
    "МЕЧТА",
    "МЕЧТЫ",
    "МЕШОК",
    "МЕЩУЙ",
    "МИГОМ",
    "МИДАС",
    "МИДИЯ",
    "МИЗЕР",
    "МИКРО",
    "МИЛЛИ",
    "МИЛЫЙ",
    "МИНЁР",
    "МИНЕЯ",
    "МИННЕ",
    "МИНОР",
    "МИНУС",
    "МИНЯЙ",
    "МИОМА",
    "МИРАЖ",
    "МИРОН",
    "МИРРА",
    "МИСКА",
    "МИТРА",
    "МИТЮК",
    "МИШКА",
    "МЛАДО",
    "МЛЕКО",
    "МЛЕТЬ",
    "МНИТЬ",
    "МНОГО",
    "МНУТЬ",
    "МОВКО",
    "МОВНЯ",
    "МОВША",
    "МОДЕН",
    "МОДОМ",
    "МОЖАЙ",
    "МОЖЕТ",
    "МОЖНО",
    "МОЙВА",
    "МОЙКА",
    "МОКИН",
    "МОКОЙ",
    "МОКСА",
    "МОЛВА",
    "МОЛЕГ",
    "МОЛЕК",
    "МОЛКА",
    "МОЛОТ",
    "МОЛОХ",
    "МОЛЧА",
    "МОМОН",
    "МОМРА",
    "МОМСА",
    "МОПЕД",
    "МОРГА",
    "МОРДА",
    "МОРОЗ",
    "МОРЦО",
    "МОРЯК",
    "МОСОЛ",
    "МОТИВ",
    "МОТКА",
    "МОТНЯ",
    "МОХНА",
    "МОЧКА",
    "МОШКА",
    "МОШНА",
    "МРАЗЬ",
    "МРЕЖА",
    "МРЕТЬ",
    "МТАХА",
    "МТИНА",
    "МУЕГА",
    "МУЖИК",
    "МУЗЕЙ",
    "МУЛАТ",
    "МУЛЛА",
    "МУЛЯЖ",
    "МУМИЁ",
    "МУМИЯ",
    "МУРАШ",
    "МУРГА",
    "МУРЗА",
    "МУРИН",
    "МУРКА",
    "МУРЛО",
    "МУРОМ",
    "МУРЬЯ",
    "МУСОР",
    "МУСЬЕ",
    "МУФТА",
    "МУФТИ",
    "МУЦУН",
    "МУЧКА",
    "МУШАН",
    "МУШКА",
    "МЦЕЛА",
    "МЧАТЬ",
    "МШЕЛЬ",
    "МШИЦА",
    "МЫКЕР",
    "МЫКИЗ",
    "МЫЛИЙ",
    "МЫМРА",
    "МЫРДА",
    "МЫСИК",
    "МЫСЛЬ",
    "МЫЧКА",
    "МЫШИЙ",
    "МЫШКА",
    "МЫШЦА",
    "МЭРИЯ",
    "МЯГКО",
    "МЯЗГА",
    "МЯКИШ",
    "МЯЛКА",
    "МЯМЛЯ",
    "МЯНДА",
    "МЯСТИ",
    "МЯТЕЖ",
    "МЯТЛЬ",
    "МЯТЫЙ",
    "НАБАТ",
    "НАБЕГ",
    "НАБОЙ",
    "НАБОК",
    "НАБОР",
    "НАВЕК",
    "НАВЕС",
    "НАВЕТ",
    "НАВИЙ",
    "НАВОЙ",
    "НАВСЕ",
    "НАГАЛ",
    "НАГОЙ",
    "НАГУЛ",
    "НАГЫШ",
    "НАДЕИ",
    "НАДЕЛ",
    "НАДИЙ",
    "НАДИР",
    "НАДОЙ",
    "НАДОР",
    "НАДРЕ",
    "НАДТО",
    "НАЕЗД",
    "НАЖИМ",
    "НАЖИН",
    "НАЖИТ",
    "НАЗАД",
    "НАЗЁМ",
    "НАЗЛО",
    "НАЗОЙ",
    "НАЙТИ",
    "НАКАТ",
    "НАКОН",
    "НАКРА",
    "НАЛЕН",
    "НАЛЁТ",
    "НАЛИВ",
    "НАЛИК",
    "НАЛИМ",
    "НАЛОГ",
    "НАЛОЙ",
    "НАЛЫМ",
    "НАМАЗ",
    "НАМЕК",
    "НАМЁТ",
    "НАМЫВ",
    "НАНКА",
    "НАОРЫ",
    "НАПЕВ",
    "НАПОЛ",
    "НАПОР",
    "НАРКО",
    "НАРОВ",
    "НАРОД",
    "НАРОК",
    "НАРОТ",
    "НАРТА",
    "НАРТЫ",
    "НАРЫВ",
    "НАРЯД",
    "НАСИД",
    "НАСОН",
    "НАСТО",
    "НАТЁК",
    "НАУКА",
    "НАУРА",
    "НАФТА",
    "НАХАЛ",
    "НАЦИЯ",
    "НАЧЁС",
    "НАЧЁТ",
    "НАЧИЯ",
    "НАЧТО",
    "НАШВЫ",
    "НАЮРУ",
    "НАЯВУ",
    "НАЯДА",
    "НДРАВ",
    "НЕ ТО",
    "НЕБЕЗ",
    "НЕБЕС",
    "НЕВЖО",
    "НЕВОД",
    "НЕВРО",
    "НЕВРЯ",
    "НЕГДЕ",
    "НЕГЛА",
    "НЕГЛИ",
    "НЕГРЫ",
    "НЕДЕЯ",
    "НЕДРА",
    "НЕДРО",
    "НЕДУГ",
    "НЕЁЛА",
    "НЕЖИД",
    "НЕИНО",
    "НЕЙРО",
    "НЕЙТИ",
    "НЕКАЗ",
    "НЕКИЙ",
    "НЕКМА",
    "НЕКТО",
    "НЕЛЮД",
    "НЕМАН",
    "НЕМИР",
    "НЕМОЙ",
    "НЕМЦЫ",
    "НЕНАШ",
    "НЕНЦЫ",
    "НЕОХА",
    "НЕПРЯ",
    "НЕРОД",
    "НЕРОЙ",
    "НЕРПА",
    "НЕРША",
    "НЕСАД",
    "НЕСТИ",
    "НЕСТЬ",
    "НЕСУН",
    "НЕТЕС",
    "НЕТИЙ",
    "НЕТТО",
    "НЕУМА",
    "НЕФТЕ",
    "НЕФТЬ",
    "НЕХАЙ",
    "НЕЧЕМ",
    "НЕЧЕТ",
    "НЕЧТО",
    "НИВХИ",
    "НИГВА",
    "НИГДЕ",
    "НИЖНЕ",
    "НИЗКО",
    "НИЗОК",
    "НИЗОМ",
    "НИКАК",
    "НИКОЙ",
    "НИКОМ",
    "НИКТО",
    "НИЛАС",
    "НИЛКА",
    "НИМФА",
    "НИРАЛ",
    "НИТКА",
    "НИТРО",
    "НИЧЕЙ",
    "НИЧТО",
    "НИЧЬЯ",
    "НИШТО",
    "НИЩИЙ",
    "НОВЫЙ",
    "НОДЬЕ",
    "НОЕТА",
    "НОЖИК",
    "НОЖКА",
    "НОЖНЫ",
    "НОЙКА",
    "НОМЕР",
    "НОРКА",
    "НОРМА",
    "НОРОВ",
    "НОРОК",
    "НОРОС",
    "НОРОТ",
    "НОСИК",
    "НОХРА",
    "НОЧВА",
    "НОЧЬЮ",
    "НУЖДА",
    "НУКЕР",
    "НУЛИК",
    "НУТРО",
    "НУТТА",
    "НЫЛАС",
    "НЫНЧЕ",
    "НЫРОК",
    "НЫТИК",
    "НЮАНС",
    "НЯРКА",
    "ОАЗИС",
    "ОБВАЛ",
    "ОБВОД",
    "ОБВОЙ",
    "ОБГОН",
    "ОБДАЛ",
    "ОБЗОЛ",
    "ОБЗОР",
    "ОБИДА",
    "ОБИТЬ",
    "ОБКОМ",
    "ОБЛАС",
    "ОБЛЕЦ",
    "ОБЛИК",
    "ОБЛОГ",
    "ОБЛОЙ",
    "ОБЛОМ",
    "ОБЛУК",
    "ОБЛЫЙ",
    "ОБМАН",
    "ОБМОИ",
    "ОБНАК",
    "ОБОРА",
    "ОБРАЗ",
    "ОБРАТ",
    "ОБРОК",
    "ОБРУБ",
    "ОБРУС",
    "ОБРУЧ",
    "ОБРЫВ",
    "ОБРЫК",
    "ОБРЯД",
    "ОБУВЬ",
    "ОБУЗА",
    "ОБУТЬ",
    "ОБХОД",
    "ОБЧЕТ",
    "ОБЩИЙ",
    "ОБЪЁМ",
    "ОБЫСК",
    "ОВАМО",
    "ОВИДЬ",
    "ОВНИЙ",
    "ОВОЩЕ",
    "ОВОЩИ",
    "ОВОЩЬ",
    "ОВРАГ",
    "ОВСЕЦ",
    "ОВСЮГ",
    "ОВЧАР",
    "ОГЛОМ",
    "ОГОНЬ",
    "ОГРЕХ",
    "ОДАЛИ",
    "ОДАЛЬ",
    "ОДЁВА",
    "ОДЁЖА",
    "ОДЕТЬ",
    "ОДОЛЯ",
    "ОДУРЬ",
    "ОЖАТЬ",
    "ОЖЕГА",
    "ОЖЕЧЬ",
    "ОЖИКА",
    "ОЖИНА",
    "ОЖИТЬ",
    "ОЗЕВА",
    "ОЗЕМЬ",
    "ОЗЕРО",
    "ОЗИМЬ",
    "ОЗНОБ",
    "ОКАТЬ",
    "ОКЕАН",
    "ОКИСЬ",
    "ОКЛАД",
    "ОКЛИК",
    "ОКОВЫ",
    "ОКОЛО",
    "ОКРИК",
    "ОКРИН",
    "ОКРОЛ",
    "ОКРОП",
    "ОКРУГ",
    "ОКСИД",
    "ОКСИЯ",
    "ОКТЕТ",
    "ОКУЛА",
    "ОКУНЬ",
    "ОЛЕНА",
    "ОЛЕНЬ",
    "ОЛИВА",
    "ОЛИМП",
    "ОЛИФА",
    "ОЛОВО",
    "ОЛОШИ",
    "ОЛЬГА",
    "ОЛЬНО",
    "ОЛЬХА",
    "ОЛЬЯЛ",
    "ОМЕГА",
    "ОМЕЖА",
    "ОМЕЛА",
    "ОМЁХА",
    "ОМЕШЬ",
    "ОМЛЕТ",
    "ОМУЛЬ",
    "ОМЫТЬ",
    "ОМЯГА",
    "ОНАВА",
    "ОНАГР",
    "ОНИКС",
    "ОНУЧА",
    "ООЛИТ",
    "ОПАЛА",
    "ОПАНА",
    "ОПАРА",
    "ОПЕКА",
    "ОПЕРА",
    "ОПЕЧЬ",
    "ОПИСЬ",
    "ОПИТЬ",
    "ОПИУМ",
    "ОПЛОТ",
    "ОПОЕК",
    "ОПОКА",
    "ОПОКО",
    "ОПОНА",
    "ОПОРА",
    "ОПРОК",
    "ОПРОС",
    "ОПТИК",
    "ОПУКА",
    "ОПУТЬ",
    "ОПЫКА",
    "ОПЯТЬ",
    "ОРАВА",
    "ОРАЛО",
    "ОРАТЬ",
    "ОРГАН",
    "ОРГИЯ",
    "ОРДАШ",
    "ОРДЕН",
    "ОРДЕР",
    "ОРЖАД",
    "ОРИОН",
    "ОРКИШ",
    "ОРЛАН",
    "ОРЛЕЦ",
    "ОРЛОП",
    "ОРМЯК",
    "ОРТИК",
    "ОРЧАК",
    "ОРЩУМ",
    "ОСАДА",
    "ОСЕБЕ",
    "ОСЕЛЬ",
    "ОСЕМЬ",
    "ОСЕНЬ",
    "ОСЁТР",
    "ОСИНА",
    "ОСКАЛ",
    "ОСКОР",
    "ОСЛАМ",
    "ОСЛИК",
    "ОСЛОЙ",
    "ОСЛОП",
    "ОСЛЯК",
    "ОСМАК",
    "ОСМИЙ",
    "ОСОБЬ",
    "ОСОКА",
    "ОСОТА",
    "ОСТЕН",
    "ОСТОВ",
    "ОСТОЛ",
    "ОСТРО",
    "ОСЫПЬ",
    "ОСЬМЬ",
    "ОСЮДА",
    "ОТАВА",
    "ОТАРА",
    "ОТБОЙ",
    "ОТБОР",
    "ОТВАЛ",
    "ОТВАМ",
    "ОТВЕС",
    "ОТВЕТ",
    "ОТВОД",
    "ОТВОЙ",
    "ОТГОН",
    "ОТГУЛ",
    "ОТДЕЛ",
    "ОТДУХ",
    "ОТДЫХ",
    "ОТЕВА",
    "ОТЕЛЬ",
    "ОТЕНЬ",
    "ОТЕТЬ",
    "ОТЕЧЬ",
    "ОТЖИГ",
    "ОТЗДЕ",
    "ОТЗЫВ",
    "ОТКОС",
    "ОТКУП",
    "ОТЛЕК",
    "ОТЛЁТ",
    "ОТЛИВ",
    "ОТНИЙ",
    "ОТОРА",
    "ОТОСА",
    "ОТПОР",
    "ОТРОГ",
    "ОТРОК",
    "ОТРУБ",
    "ОТРЫВ",
    "ОТРЯД",
    "ОТСЕВ",
    "ОТТОК",
    "ОТТОР",
    "ОТХОД",
    "ОТХОН",
    "ОТЦОВ",
    "ОТЧЁТ",
    "ОТЧИЙ",
    "ОТЧИМ",
    "ОТЧИЧ",
    "ОТШИБ",
    "ОТЪЁМ",
    "ОТЫДЕ",
    "ОТЫДИ",
    "ОФЕНЯ",
    "ОФСЕТ",
    "ОХАТЬ",
    "ОХАХА",
    "ОХЛОЙ",
    "ОХЛУП",
    "ОХОТА",
    "ОХРАК",
    "ОЧЕНЬ",
    "ОЧЕРК",
    "ОЧЕСА",
    "ОЧКУР",
    "ОЧНИК",
    "ОЧНЫЙ",
    "ОШАРА",
    "ОШЕЕК",
    "ОШКУЙ",
    "ОШТОЛ",
    "ОШУЮЮ",
    "ОЩУПЬ",
    "ПАБЕД",
    "ПАВЕЛ",
    "ПАВКО",
    "ПАВНА",
    "ПАВОК",
    "ПАВУК",
    "ПАВУН",
    "ПАГУР",
    "ПАДЁЖ",
    "ПАДОГ",
    "ПАДУБ",
    "ПАДУН",
    "ПАДЫМ",
    "ПАЖЕК",
    "ПАЗУР",
    "ПАИНА",
    "ПАЙБА",
    "ПАЙКА",
    "ПАЙМО",
    "ПАКАН",
    "ПАКЕТ",
    "ПАКЛЯ",
    "ПАЛАХ",
    "ПАЛАЧ",
    "ПАЛАШ",
    "ПАЛЁД",
    "ПАЛЕЖ",
    "ПАЛЕО",
    "ПАЛЕХ",
    "ПАЛЕЦ",
    "ПАЛЕЯ",
    "ПАЛИК",
    "ПАЛКА",
    "ПАЛЬЯ",
    "ПАМЖА",
    "ПАМХА",
    "ПАНГА",
    "ПАНДА",
    "ПАНЕР",
    "ПАНИР",
    "ПАНКА",
    "ПАННА",
    "ПАННО",
    "ПАНТЫ",
    "ПАНЫР",
    "ПАПАХ",
    "ПАПИР",
    "ПАПКА",
    "ПАРАД",
    "ПАРАФ",
    "ПАРГА",
    "ПАРЕЗ",
    "ПАРИК",
    "ПАРИЯ",
    "ПАРКА",
    "ПАРМА",
    "ПАРОЙ",
    "ПАРОМ",
    "ПАРТА",
    "ПАРУС",
    "ПАРЧА",
    "ПАРША",
    "ПАРШИ",
    "ПАСИК",
    "ПАСМО",
    "ПАСТИ",
    "ПАСТЬ",
    "ПАСХА",
    "ПАСЮК",
    "ПАТЕР",
    "ПАТЛА",
    "ПАТУР",
    "ПАТЬЯ",
    "ПАУЗА",
    "ПАУТЬ",
    "ПАФОС",
    "ПАХВА",
    "ПАХТА",
    "ПАЦАН",
    "ПАЦЮК",
    "ПАЧКА",
    "ПАШНЯ",
    "ПАЯЗЬ",
    "ПАЯТЬ",
    "ПЕВЕЦ",
    "ПЕГАС",
    "ПЕГИЙ",
    "ПЕКЛО",
    "ПЕКУР",
    "ПЕКУС",
    "ПЕКЧИ",
    "ПЕМЗА",
    "ПЕНАЛ",
    "ПЕНИЕ",
    "ПЕНКА",
    "ПЕННИ",
    "ПЕНЯЗ",
    "ПЕПЕЛ",
    "ПЕРВО",
    "ПЕРГА",
    "ПЕРЁД",
    "ПЕРЁЖ",
    "ПЕРЕЗ",
    "ПЕРЕК",
    "ПЕРЕЦ",
    "ПЁРКА",
    "ПЕРСИ",
    "ПЕРСТ",
    "ПЕРСЫ",
    "ПЕРТЫ",
    "ПЕРТЬ",
    "ПЕРУН",
    "ПЕСЕЦ",
    "ПЕСНЬ",
    "ПЕСНЯ",
    "ПЕСОК",
    "ПЕТЕЛ",
    "ПЕТИТ",
    "ПЕТЛЯ",
    "ПЕТУХ",
    "ПЁХОМ",
    "ПЕЧКА",
    "ПЕЧОК",
    "ПЕШИЙ",
    "ПЕШКА",
    "ПЕШНЯ",
    "ПЕЩЕР",
    "ПИАЛА",
    "ПИАНО",
    "ПИГАН",
    "ПИГВА",
    "ПИГУС",
    "ПИЕСА",
    "ПИЖМА",
    "ПИЖОН",
    "ПИКАН",
    "ПИКАП",
    "ПИКЕТ",
    "ПИКША",
    "ПИЛАВ",
    "ПИЛКА",
    "ПИЛОТ",
    "ПИНКА",
    "ПИНОК",
    "ПИНТА",
    "ПИРАТ",
    "ПИРОГ",
    "ПИРОН",
    "ПИСЕЦ",
    "ПИСМИ",
    "ПИТЕР",
    "ПИТОН",
    "ПИТЧА",
    "ПИТЬЁ",
    "ПИХРА",
    "ПИХТА",
    "ПИЦЦА",
    "ПИШКА",
    "ПИЩИК",
    "ПЛАМЯ",
    "ПЛАСТ",
    "ПЛАТА",
    "ПЛАТО",
    "ПЛАУН",
    "ПЛАХА",
    "ПЛЕВА",
    "ПЛЕЛЬ",
    "ПЛЕМЯ",
    "ПЛЕНА",
    "ПЛЕСК",
    "ПЛЕТЬ",
    "ПЛЕХТ",
    "ПЛЕЧО",
    "ПЛЕШЬ",
    "ПЛИТА",
    "ПЛИТЬ",
    "ПЛИЦА",
    "ПЛОДО",
    "ПЛОТА",
    "ПЛОТЬ",
    "ПЛОХА",
    "ПЛЫТЬ",
    "ПЛЮХА",
    "ПНАТЬ",
    "ПНУТЬ",
    "ПОБЕГ",
    "ПОБОИ",
    "ПОБОЙ",
    "ПОБОР",
    "ПОВАЛ",
    "ПОВАР",
    "ПОВЕК",
    "ПОВОД",
    "ПОВОЙ",
    "ПОВОР",
    "ПОГАЧ",
    "ПОГОН",
    "ПОДИР",
    "ПОДИЯ",
    "ПОДЛЕ",
    "ПОДОГ",
    "ПОДОЛ",
    "ПОДПИ",
    "ПОЕЗД",
    "ПОЖАР",
    "ПОЖДЬ",
    "ПОЖЕГ",
    "ПОЖНЯ",
    "ПОЖОГ",
    "ПОЗЕМ",
    "ПОЗЁР",
    "ПОЗЖЕ",
    "ПОЗОР",
    "ПОЗЫВ",
    "ПОИВА",
    "ПОИВО",
    "ПОИСК",
    "ПОИТЬ",
    "ПОЙГА",
    "ПОЙКА",
    "ПОЙЛО",
    "ПОЙМА",
    "ПОЙТИ",
    "ПОКАЙ",
    "ПОКАЛ",
    "ПОКЕР",
    "ПОКОИ",
    "ПОКОЙ",
    "ПОКОН",
    "ПОКОС",
    "ПОКУС",
    "ПОКУТ",
    "ПОКША",
    "ПОЛАС",
    "ПОЛБА",
    "ПОЛЁГ",
    "ПОЛЕЙ",
    "ПОЛИП",
    "ПОЛИС",
    "ПОЛИТ",
    "ПОЛКА",
    "ПОЛМА",
    "ПОЛНО",
    "ПОЛОГ",
    "ПОЛОЗ",
    "ПОЛОЙ",
    "ПОЛОК",
    "ПОЛОН",
    "ПОЛТЬ",
    "ПОЛЫЙ",
    "ПОЛЮС",
    "ПОЛЮХ",
    "ПОЛЯК",
    "ПОМЕЖ",
    "ПОМЁТ",
    "ПОМЖА",
    "ПОМИН",
    "ПОМОИ",
    "ПОМОЛ",
    "ПОМОР",
    "ПОМПА",
    "ПОМХА",
    "ПОМЦЫ",
    "ПОНАС",
    "ПОНОС",
    "ПОНЦЫ",
    "ПОНЧО",
    "ПОНЫР",
    "ПОПЕЛ",
    "ПОПКА",
    "ПОПРИ",
    "ПОПСА",
    "ПОРАЗ",
    "ПОРЕЙ",
    "ПОРКА",
    "ПОРКО",
    "ПОРНО",
    "ПОРОГ",
    "ПОРОЙ",
    "ПОРОК",
    "ПОРОМ",
    "ПОРОХ",
    "ПОРОЮ",
    "ПОРСА",
    "ПОРТА",
    "ПОРТЫ",
    "ПОРУЗ",
    "ПОРУХ",
    "ПОРЧА",
    "ПОРЫВ",
    "ПОСАГ",
    "ПОСАД",
    "ПОСЕВ",
    "ПОСИК",
    "ПОСЛЕ",
    "ПОСОЛ",
    "ПОСОМ",
    "ПОСОП",
    "ПОСОХ",
    "ПОСПА",
    "ПОСУЛ",
    "ПОСЫЛ",
    "ПОТАШ",
    "ПОТЁК",
    "ПОТИР",
    "ПОТКА",
    "ПОТОК",
    "ПОТОМ",
    "ПОТОП",
    "ПОТФА",
    "ПОТЧА",
    "ПОХАБ",
    "ПОХОД",
    "ПОЧВА",
    "ПОЧЕМ",
    "ПОЧЁТ",
    "ПОЧИН",
    "ПОЧИР",
    "ПОЧКА",
    "ПОЧКИ",
    "ПОЧТА",
    "ПОЧТИ",
    "ПОЧТО",
    "ПОШИБ",
    "ПОШОВ",
    "ПОШТО",
    "ПОЭМА",
    "ПОЯТЬ",
    "ПРАВО",
    "ПРАСА",
    "ПРАСК",
    "ПРАТЬ",
    "ПРАЦА",
    "ПРАЩА",
    "ПРЕДИ",
    "ПРЕДО",
    "ПРЕДЪ",
    "ПРЕКА",
    "ПРЕЛЬ",
    "ПРЕСС",
    "ПРЕТЬ",
    "ПРИБА",
    "ПРИВО",
    "ПРИЁМ",
    "ПРИКА",
    "ПРИМА",
    "ПРИНА",
    "ПРИНЦ",
    "ПРИУЗ",
    "ПРИУХ",
    "ПРИЧТ",
    "ПРИЮТ",
    "ПРОБА",
    "ПРОЁМ",
    "ПРОЗА",
    "ПРОСО",
    "ПРОТЕ",
    "ПРОТО",
    "ПРОУХ",
    "ПРОЧЬ",
    "ПРОЩА",
    "ПРЫТЬ",
    "ПРЯГА",
    "ПРЯДЬ",
    "ПРЯЖА",
    "ПРЯМО",
    "ПРЯХА",
    "ПСАРЬ",
    "ПСАТИ",
    "ПСИНА",
    "ПСИХО",
    "ПСОРА",
    "ПТАХА",
    "ПТИЦА",
    "ПУВАК",
    "ПУГАЧ",
    "ПУДАС",
    "ПУДРА",
    "ПУЕГА",
    "ПУЗАН",
    "ПУКАС",
    "ПУКЛЯ",
    "ПУКША",
    "ПУЛАЙ",
    "ПУЛКО",
    "ПУЛЬС",
    "ПУЛЬТ",
    "ПУМПА",
    "ПУНДА",
    "ПУНКТ",
    "ПУПОК",
    "ПУРГА",
    "ПУРКА",
    "ПУРЫШ",
    "ПУСКО",
    "ПУСМА",
    "ПУСОХ",
    "ПУСТО",
    "ПУСТЬ",
    "ПУТЁМ",
    "ПУТИК",
    "ПУТИН",
    "ПУТРА",
    "ПУЧКА",
    "ПУЧОК",
    "ПУШКА",
    "ПУШОК",
    "ПУЩИЙ",
    "ПХАТЬ",
    "ПЧЕЛА",
    "ПШЕНО",
    "ПЫЖИК",
    "ПЫРЕЙ",
    "ПЫТКА",
    "ПЫЧКИ",
    "ПЫШКА",
    "ПЫЩИЙ",
    "ПЬЕСА",
    "ПЬЯНЬ",
    "ПЯНДА",
    "ПЯСТЬ",
    "ПЯТАК",
    "ПЯТКА",
    "ПЯТНО",
    "ПЯТОК",
    "ПЯТРА",
    "ПЯТЫЙ",
    "РАБАЧ",
    "РАВГА",
    "РАВЗЕ",
    "РАВНО",
    "РАДАР",
    "РАДЖА",
    "РАДИЙ",
    "РАДИО",
    "РАДОН",
    "РАЕКА",
    "РАЖИЙ",
    "РАЖКИ",
    "РАЗВЕ",
    "РАЗВО",
    "РАЗНО",
    "РАЗНЬ",
    "РАЗОМ",
    "РАЗОР",
    "РАЗУМ",
    "РАИНА",
    "РАИТЬ",
    "РАЙДА",
    "РАЙНА",
    "РАЙОН",
    "РАКСА",
    "РАКУН",
    "РАКША",
    "РАЛЛИ",
    "РАМЕН",
    "РАМЖА",
    "РАМКА",
    "РАМПА",
    "РАМША",
    "РАНЕЕ",
    "РАНЕТ",
    "РАНЕЦ",
    "РАННЕ",
    "РАНЧО",
    "РАСТИ",
    "РАТАЙ",
    "РАТАН",
    "РАТАХ",
    "РАТКА",
    "РАФИК",
    "РАХЕЛ",
    "РАХИТ",
    "РАХЛЯ",
    "РАЦЕЯ",
    "РАЦИЯ",
    "РАЧИЙ",
    "РАЧОК",
    "РАЯТЬ",
    "РВАНЬ",
    "РВАТЬ",
    "РВИНА",
    "РВОТА",
    "РДЕСТ",
    "РДЕТЬ",
    "РЕБЕЗ",
    "РЕБРО",
    "РЕБУС",
    "РЁВКА",
    "РЕВМЯ",
    "РЕГБИ",
    "РЕДАН",
    "РЕДИС",
    "РЕДУТ",
    "РЕЖИМ",
    "РЕЖКА",
    "РЕЗАК",
    "РЕЗЕЦ",
    "РЕЗКА",
    "РЕЗНЯ",
    "РЕЗОН",
    "РЕЗУС",
    "РЕЙЕР",
    "РЕЙКА",
    "РЕКЛО",
    "РЕЛЬС",
    "РЕМЕЗ",
    "РЕМИЗ",
    "РЕМОХ",
    "РЕНТА",
    "РЕПЕЙ",
    "РЕПИК",
    "РЕТИС",
    "РЕТРО",
    "РЕФЕТ",
    "РЕЧКА",
    "РЕШКА",
    "РЕШМА",
    "РЕЯТЬ",
    "РЖАТЬ",
    "РИКША",
    "РИТОР",
    "РИФМА",
    "РИЦИН",
    "РОБОТ",
    "РОВГА",
    "РОВДА",
    "РОВНО",
    "РОВНЯ",
    "РОГАЧ",
    "РОДЕО",
    "РОДИЙ",
    "РОДИЧ",
    "РОДНЯ",
    "РОДЫЙ",
    "РОЖЕК",
    "РОЖОК",
    "РОЖОН",
    "РОЗАН",
    "РОЗГА",
    "РОЗНО",
    "РОЗНЬ",
    "РОИТЬ",
    "РОЙКИ",
    "РОКЕР",
    "РОКЕТ",
    "РОКЛЯ",
    "РОКОТ",
    "РОКША",
    "РОЛИК",
    "РОМАН",
    "РОМША",
    "РОНДО",
    "РОНЖА",
    "РОПАК",
    "РОПОТ",
    "РОСТИ",
    "РОТИЯ",
    "РОТОР",
    "РОХЛЯ",
    "РОЧЕГ",
    "РОЯЛЬ",
    "РТУТЬ",
    "РУБАН",
    "РУБЕЖ",
    "РУБЕЦ",
    "РУБИН",
    "РУБКА",
    "РУБЛЬ",
    "РУГНЯ",
    "РУДОЙ",
    "РУЖЬЁ",
    "РУИНА",
    "РУИТЬ",
    "РУКАВ",
    "РУКОП",
    "РУЛЕК",
    "РУЛЕТ",
    "РУЛОН",
    "РУМБА",
    "РУПАК",
    "РУПАС",
    "РУПИЯ",
    "РУПОР",
    "РУСАК",
    "РУСЛО",
    "РУСЫЙ",
    "РУТКА",
    "РУЧЕЙ",
    "РУЧКА",
    "РЫБАК",
    "РЫБЕЦ",
    "РЫБИЙ",
    "РЫБНЯ",
    "РЫВОК",
    "РЫЖИЙ",
    "РЫЖИК",
    "РЫНДА",
    "РЫНКА",
    "РЫНОК",
    "РЫСАК",
    "РЫСИЙ",
    "РЫСЦА",
    "РЫЧАГ",
    "РЫЧЕК",
    "РЭКЕТ",
    "РЮЕНЬ",
    "РЮМКА",
    "РЮШКА",
    "РЯБОЙ",
    "РЯБЫЙ",
    "РЯДНО",
    "РЯДОМ",
    "РЯЖКА",
    "РЯМОК",
    "РЯНДА",
    "РЯСКА",
    "РЯШКА",
    "СААМИ",
    "СААМЫ",
    "САБАН",
    "САБЛЯ",
    "САБУР",
    "САВАН",
    "САВКА",
    "САВРЫ",
    "САГАН",
    "САДАК",
    "САДЖА",
    "САДИК",
    "САДОК",
    "САЗАН",
    "САИМА",
    "САЙБА",
    "САЙВА",
    "САЙГА",
    "САЙДА",
    "САЙКА",
    "САЙРА",
    "САКЛЯ",
    "САКМА",
    "САКША",
    "САЛАТ",
    "САЛЕП",
    "САЛЕЦ",
    "САЛКИ",
    "САЛМА",
    "САЛОН",
    "САЛОП",
    "САЛПА",
    "САЛЮТ",
    "САМАН",
    "САМБА",
    "САМБО",
    "САМЕЦ",
    "САМКА",
    "САМРА",
    "САМУМ",
    "САМУР",
    "САМЫЙ",
    "САНГА",
    "САНКИ",
    "САНТИ",
    "САПЁР",
    "САПЕЦ",
    "САПОГ",
    "САРАЙ",
    "САРГА",
    "САРЖА",
    "САРМА",
    "САРНА",
    "САРЫЧ",
    "САРЬЯ",
    "САТАН",
    "САТИН",
    "САТИР",
    "САУНА",
    "САФИР",
    "САФОЙ",
    "САХАР",
    "САХТА",
    "САЧОК",
    "СБИТЬ",
    "СБОКУ",
    "СБОЧЬ",
    "СБРОД",
    "СБРУЯ",
    "СБЫТЬ",
    "СВАНЫ",
    "СВАРА",
    "СВАХА",
    "СВЕЖЕ",
    "СВЕНЕ",
    "СВЕРХ",
    "СВЕРЩ",
    "СВЕТО",
    "СВЕЧА",
    "СВЕЩА",
    "СВИЗЬ",
    "СВИЛЬ",
    "СВИСТ",
    "СВИТА",
    "СВИТЬ",
    "СВОНУ",
    "СВОРА",
    "СВОЯК",
    "СВЫШЕ",
    "СВЯЗЬ",
    "СВЯСЬ",
    "СДАЛЯ",
    "СДАТЬ",
    "СДАЧА",
    "СДВИГ",
    "СДОБА",
    "СДУРУ",
    "СДУТЬ",
    "СЕАНС",
    "СЕБЕР",
    "СЕВЕР",
    "СЕВЕЦ",
    "СЕДЛО",
    "СЕДМЬ",
    "СЕДНИ",
    "СЕДОЙ",
    "СЕДОК",
    "СЕЗОН",
    "СЕЙДЫ",
    "СЕКАС",
    "СЕКАЧ",
    "СЕКТА",
    "СЕЛЕН",
    "СЁМГА",
    "СЕМЬЮ",
    "СЕМЬЯ",
    "СЕНАЖ",
    "СЕНАТ",
    "СЕНКИ",
    "СЕПИЯ",
    "СЕРАФ",
    "СЕРБЫ",
    "СЕРЕН",
    "СЕРИЯ",
    "СЕРНА",
    "СЕРСО",
    "СЕРЫЙ",
    "СЕСНО",
    "СЕСТЬ",
    "СЕТКА",
    "СЕУНЧ",
    "СЕЧКА",
    "СЕЯТЬ",
    "СЖАТЬ",
    "СЖЕЧЬ",
    "СЖИТЬ",
    "СЗАДИ",
    "СЗАДУ",
    "СИВЕР",
    "СИВКА",
    "СИВКО",
    "СИВУЧ",
    "СИВЫЙ",
    "СИДМЯ",
    "СИДОР",
    "СИЕНЬ",
    "СИЗЫЙ",
    "СИКЕР",
    "СИЛАЧ",
    "СИЛОЙ",
    "СИЛОК",
    "СИЛОС",
    "СИНЕЦ",
    "СИНИЙ",
    "СИНОД",
    "СИНУС",
    "СИНЯК",
    "СИРИН",
    "СИРКА",
    "СИРОП",
    "СИРТЬ",
    "СИРЫЙ",
    "СИТЕЦ",
    "СИТРО",
    "СИФОН",
    "СИЯТЬ",
    "СКАБА",
    "СКАЛА",
    "СКАНЬ",
    "СКАРА",
    "СКАРБ",
    "СКАФА",
    "СКВЕР",
    "СКЕЛЯ",
    "СКЕТЧ",
    "СКИПА",
    "СКИРД",
    "СКИФЫ",
    "СКЛАД",
    "СКЛЕП",
    "СКЛОН",
    "СКЛЯД",
    "СКОБА",
    "СКОЛЬ",
    "СКОНС",
    "СКОПА",
    "СКОРА",
    "СКОРО",
    "СКОТО",
    "СКРИН",
    "СКРИП",
    "СКУДА",
    "СКУКА",
    "СКУЛА",
    "СКУЛЯ",
    "СКУНС",
    "СЛАБО",
    "СЛАВА",
    "СЛАЙД",
    "СЛАМА",
    "СЛАТЬ",
    "СЛЕВА",
    "СЛЕГА",
    "СЛЕЗА",
    "СЛЕМЯ",
    "СЛЕТЬ",
    "СЛЕЧЬ",
    "СЛИВА",
    "СЛИЗЬ",
    "СЛИНА",
    "СЛИТЬ",
    "СЛИХА",
    "СЛОВО",
    "СЛОТА",
    "СЛУГА",
    "СЛУДА",
    "СЛУКА",
    "СЛЫТЬ",
    "СЛЫШЬ",
    "СЛЮДА",
    "СЛЮНА",
    "СЛЮНИ",
    "СЛЯГА",
    "СМАГА",
    "СМАЛУ",
    "СМЕНА",
    "СМЕРД",
    "СМЕРЧ",
    "СМЕСЬ",
    "СМЕТА",
    "СМЕТЬ",
    "СМОЛА",
    "СМОЛЬ",
    "СМОТР",
    "СМОЧЬ",
    "СМРАД",
    "СМУГА",
    "СМУТА",
    "СМУХА",
    "СМЫТЬ",
    "СМЯТЬ",
    "СНАГА",
    "СНАШЕ",
    "СНЕГО",
    "СНЕДЬ",
    "СНИЗУ",
    "СНИТЬ",
    "СНИЦА",
    "СНОВА",
    "СНОЗА",
    "СНОСИ",
    "СНОТА",
    "СНОХА",
    "СНУТЬ",
    "СНЯТЬ",
    "СОБЕС",
    "СОБОР",
    "СОБОЮ",
    "СОБЩА",
    "СОВЕТ",
    "СОВКА",
    "СОВОК",
    "СОВХО",
    "СОГРА",
    "СОДИЙ",
    "СОДОМ",
    "СОЖАР",
    "СОЗЛА",
    "СОЙДА",
    "СОЙКА",
    "СОЙМА",
    "СОЙТИ",
    "СОКМА",
    "СОКОЛ",
    "СОКУЙ",
    "СОЛЕЯ",
    "СОЛОД",
    "СОЛОН",
    "СОЛПА",
    "СОЛЯР",
    "СОМЕЦ",
    "СОМОН",
    "СОНЕТ",
    "СОПЕЦ",
    "СОПКА",
    "СОПЛИ",
    "СОПЛО",
    "СОПЛЯ",
    "СОПОТ",
    "СОПЧА",
    "СОРГО",
    "СОРМА",
    "СОРОК",
    "СОРОМ",
    "СОСЕД",
    "СОСЕЦ",
    "СОСИС",
    "СОСКА",
    "СОСНА",
    "СОСОК",
    "СОСУД",
    "СОСУН",
    "СОСЦЫ",
    "СОТКА",
    "СОТНЯ",
    "СОТЫЙ",
    "СОФИТ",
    "СОЦИО",
    "СОШКА",
    "СПАЗМ",
    "СПАТЬ",
    "СПЕЖА",
    "СПЕНЬ",
    "СПЕСЬ",
    "СПЕТЬ",
    "СПЕЧЬ",
    "СПИНА",
    "СПИРТ",
    "СПИЦА",
    "СПИЩЕ",
    "СПЛАВ",
    "СПЛЕК",
    "СПЛИН",
    "СПОЖА",
    "СПОЗА",
    "СПОЛУ",
    "СПОНА",
    "СПОРА",
    "СПОРТ",
    "СПОРЫ",
    "СПРОС",
    "СПРУТ",
    "СПРЫЧ",
    "СПУСК",
    "СРАЗУ",
    "СРЕДА",
    "СРЕДИ",
    "СРЕДЬ",
    "СРОДУ",
    "СРОЕК",
    "СРОЗЬ",
    "СРЫТЬ",
    "СРЯДУ",
    "СРЯЩА",
    "ССЕЧЬ",
    "ССОРА",
    "ССУДА",
    "СТАДО",
    "СТАЛЬ",
    "СТАНС",
    "СТАРО",
    "СТАРТ",
    "СТАТЬ",
    "СТВОЛ",
    "СТВОР",
    "СТЕЗЯ",
    "СТЕКА",
    "СТЕЛА",
    "СТЕЛЬ",
    "СТЕНА",
    "СТЕНД",
    "СТЕНЬ",
    "СТЕПС",
    "СТЕПЬ",
    "СТЕРХ",
    "СТЁХА",
    "СТЕЧЬ",
    "СТИДЬ",
    "СТИЖЬ",
    "СТИЛЬ",
    "СТИНЫ",
    "СТИНЬ",
    "СТИШЬ",
    "СТКЛО",
    "СТОЁК",
    "СТОИК",
    "СТОЛБ",
    "СТОЛП",
    "СТОЛЬ",
    "СТОПА",
    "СТОРА",
    "СТОФЬ",
    "СТОЯК",
    "СТРАЖ",
    "СТРАМ",
    "СТРАХ",
    "СТРЕЖ",
    "СТРИЖ",
    "СТРИЙ",
    "СТРИК",
    "СТРОЙ",
    "СТРОП",
    "СТРУБ",
    "СТРУГ",
    "СТРУК",
    "СТРУП",
    "СТРУЯ",
    "СТРЫГ",
    "СТРЫЙ",
    "СТУДА",
    "СТУЖА",
    "СТУЛО",
    "СТУПА",
    "СТУЦЫ",
    "СТЫЛУ",
    "СТЫТЬ",
    "СТЯТИ",
    "СУБОЙ",
    "СУБОР",
    "СУГОР",
    "СУДАК",
    "СУДИЯ",
    "СУДНО",
    "СУДОК",
    "СУДЬЯ",
    "СУЕТА",
    "СУЗИК",
    "СУЗОК",
    "СУЙМА",
    "СУКНО",
    "СУЛЕЯ",
    "СУЛОЙ",
    "СУЛОК",
    "СУМАХ",
    "СУМКА",
    "СУММА",
    "СУМУН",
    "СУНША",
    "СУПЕР",
    "СУПОР",
    "СУПРЯ",
    "СУРИК",
    "СУРНА",
    "СУРОК",
    "СУРОМ",
    "СУРПА",
    "СУРЫЖ",
    "СУРЯК",
    "СУСАК",
    "СУСЕД",
    "СУСЕК",
    "СУСЛО",
    "СУТАЖ",
    "СУТКИ",
    "СУФЛЕ",
    "СУХОЙ",
    "СУЦАЯ",
    "СУЧКА",
    "СУЧОК",
    "СУШКА",
    "СУЩИЙ",
    "СФЕРА",
    "СХЕМА",
    "СХИМА",
    "СЦЕНА",
    "СЧЁТЫ",
    "СШИТЬ",
    "СЪЕЗД",
    "СЪЯТЬ",
    "СЫНГА",
    "СЫНОК",
    "СЫРЕЦ",
    "СЫРКА",
    "СЫРОЙ",
    "СЫРОК",
    "СЫРОП",
    "СЫРЬЁ",
    "СЫСЯК",
    "СЫТЫЙ",
    "СЫЧУГ",
    "СЫЩИК",
    "СЮЖЕТ",
    "СЮЗЁМ",
    "СЮИТА",
    "СЮКУР",
    "СЮРМА",
    "СЯБЕР",
    "СЯДНИ",
    "СЯКОЙ",
    "СЯМБА",
    "ТАБАК",
    "ТАБЛО",
    "ТАБОР",
    "ТАБУН",
    "ТАВРО",
    "ТАВУН",
    "ТАВЫТ",
    "ТАГАН",
    "ТАГАР",
    "ТАГАС",
    "ТАГУН",
    "ТАЖДЕ",
    "ТАЖКА",
    "ТАИТЬ",
    "ТАЙГА",
    "ТАЙКА",
    "ТАЙНА",
    "ТАЙША",
    "ТАКЖЕ",
    "ТАКОВ",
    "ТАКОЙ",
    "ТАКСА",
    "ТАКСИ",
    "ТАКТА",
    "ТАКЬЯ",
    "ТАЛАЙ",
    "ТАЛДЫ",
    "ТАЛЕР",
    "ТАЛЕЦ",
    "ТАЛИЯ",
    "ТАЛОН",
    "ТАЛЫЙ",
    "ТАЛЬК",
    "ТАМАК",
    "ТАМАР",
    "ТАМГА",
    "ТАМЫР",
    "ТАНАК",
    "ТАНГО",
    "ТАНЕЦ",
    "ТАНИК",
    "ТАНИН",
    "ТАНОК",
    "ТАПЁР",
    "ТАПИР",
    "ТАПТА",
    "ТАРАН",
    "ТАРИФ",
    "ТАРКА",
    "ТАРЬЯ",
    "ТАСКА",
    "ТАСМА",
    "ТАФТА",
    "ТАФЬЯ",
    "ТАХТА",
    "ТАЧКА",
    "ТАШКА",
    "ТАЯТЬ",
    "ТВАЛЬ",
    "ТВАРЬ",
    "ТВИРЬ",
    "ТВИСТ",
    "ТЕАТР",
    "ТЕВЯК",
    "ТЕЗЁК",
    "ТЕЗИС",
    "ТЁЗКА",
    "ТЕИЗМ",
    "ТЕКСТ",
    "ТЕЛЕЦ",
    "ТЁЛКА",
    "ТЕЛОК",
    "ТЕЛУР",
    "ТЕМБР",
    "ТЕМНО",
    "ТЕНГИ",
    "ТЕНЁК",
    "ТЕНОР",
    "ТЕПЛО",
    "ТЕПНЯ",
    "ТЕПТИ",
    "ТЕРЕМ",
    "ТЕРЕН",
    "ТЁРКА",
    "ТЕРМО",
    "ТЕРНО",
    "ТЕСАК",
    "ТЕСКА",
    "ТЕСЛА",
    "ТЕСТО",
    "ТЕСТЬ",
    "ТЁТКА",
    "ТЕФАН",
    "ТЕХНО",
    "ТЕЧКА",
    "ТИАРА",
    "ТИВУН",
    "ТИНДА",
    "ТИПАЖ",
    "ТИПЕЦ",
    "ТИПУН",
    "ТИРАЖ",
    "ТИРАН",
    "ТИРСА",
    "ТИРСО",
    "ТИСКА",
    "ТИСКИ",
    "ТИТАН",
    "ТИТЛА",
    "ТИТЛО",
    "ТИТУЛ",
    "ТИФОН",
    "ТИФУС",
    "ТИХИЙ",
    "ТКАНЬ",
    "ТКАТЬ",
    "ТЛЕТЬ",
    "ТМИТЬ",
    "ТНИТИ",
    "ТОВАР",
    "ТОГДА",
    "ТОГОЛ",
    "ТОЖДЕ",
    "ТОЙОН",
    "ТОКМО",
    "ТОЛДЫ",
    "ТОЛКИ",
    "ТОЛМА",
    "ТОЛОЙ",
    "ТОЛОК",
    "ТОЛПА",
    "ТОЛУЙ",
    "ТОЛЧА",
    "ТОЛЩА",
    "ТОМАН",
    "ТОМАР",
    "ТОМАТ",
    "ТОНКО",
    "ТОННА",
    "ТОНУС",
    "ТОПАЗ",
    "ТОПКА",
    "ТОПКИ",
    "ТОПОР",
    "ТОПОТ",
    "ТОРАК",
    "ТОРБА",
    "ТОРГИ",
    "ТОРЕЦ",
    "ТОРИЙ",
    "ТОРОВ",
    "ТОРОЗ",
    "ТОРОС",
    "ТОРПА",
    "ТОРФО",
    "ТОСКА",
    "ТОТЕМ",
    "ТОХЪЯ",
    "ТОЧЕК",
    "ТОЧИЮ",
    "ТОЧКА",
    "ТОЧОК",
    "ТОЩИЙ",
    "ТРАВА",
    "ТРАВО",
    "ТРАКТ",
    "ТРАНС",
    "ТРАТА",
    "ТРАТЬ",
    "ТРАУР",
    "ТРЕБА",
    "ТРЁКА",
    "ТРЕЛЬ",
    "ТРЕСК",
    "ТРЕСТ",
    "ТРЕТЬ",
    "ТРЕУХ",
    "ТРЕФЫ",
    "ТРЕЩА",
    "ТРИЕР",
    "ТРИКО",
    "ТРИОД",
    "ТРОЕК",
    "ТРОКА",
    "ТРОМБ",
    "ТРОПА",
    "ТРОХА",
    "ТРОЯК",
    "ТРУБА",
    "ТРУБО",
    "ТРУДО",
    "ТРУНА",
    "ТРУПА",
    "ТРУСЫ",
    "ТРУХА",
    "ТРЫТИ",
    "ТРЮМО",
    "ТУГОЙ",
    "ТУЗИК",
    "ТУЛАЙ",
    "ТУЛИК",
    "ТУЛУК",
    "ТУЛУМ",
    "ТУЛУН",
    "ТУЛУП",
    "ТУЛЬЯ",
    "ТУМАК",
    "ТУМАН",
    "ТУМБА",
    "ТУНЕЦ",
    "ТУПАК",
    "ТУПАН",
    "ТУПЕЁ",
    "ТУПЕЙ",
    "ТУПИК",
    "ТУПОЙ",
    "ТУПЯК",
    "ТУРАХ",
    "ТУРАЧ",
    "ТУРБА",
    "ТУРБО",
    "ТУРЖА",
    "ТУРКА",
    "ТУРКИ",
    "ТУРНЕ",
    "ТУРОК",
    "ТУРЧА",
    "ТУТЕН",
    "ТУФЛИ",
    "ТУФТА",
    "ТУЦИЯ",
    "ТУШКА",
    "ТЩЕТА",
    "ТЩИНА",
    "ТЫКВА",
    "ТЫКЕН",
    "ТЫНДА",
    "ТЫРБА",
    "ТЫРЛО",
    "ТЫЧЕК",
    "ТЫЧОК",
    "ТЮБИК",
    "ТЮБКА",
    "ТЮНЕЙ",
    "ТЮНЕК",
    "ТЮНИК",
    "ТЮПКА",
    "ТЮРИК",
    "ТЮРКИ",
    "ТЮТЮН",
    "ТЮФЯК",
    "ТЮХТЯ",
    "ТЮШКА",
    "ТЯБЛО",
    "ТЯГАЧ",
    "ТЯГЛА",
    "ТЯГЛО",
    "ТЯГЛЫ",
    "ТЯГОЙ",
    "ТЯЖАК",
    "ТЯЖБА",
    "ТЯЖКА",
    "ТЯЛУН",
    "ТЯПКА",
    "УАЗИК",
    "УБЕЧЬ",
    "УБИТЬ",
    "УБРУС",
    "УБЫЛЬ",
    "УБЫТЬ",
    "УВИТЬ",
    "УВОЧЬ",
    "УГЛАН",
    "УГОДА",
    "УГОЛА",
    "УГОЛЬ",
    "УГОРЬ",
    "УДАЛЬ",
    "УДАТЬ",
    "УДАЧА",
    "УДЕРЖ",
    "УДИЛА",
    "УДИЛО",
    "УДИТЬ",
    "УДОБО",
    "УДОВА",
    "УДУТЬ",
    "УДЭХЭ",
    "УЕСТЬ",
    "УЖАТЬ",
    "УЖЕЛИ",
    "УЖИЩЕ",
    "УЖНЫЙ",
    "УЗВАР",
    "УЗДЦА",
    "УЗИНА",
    "УЗИТЬ",
    "УЗКИЙ",
    "УЗНИК",
    "УЗРОК",
    "УКАЗИ",
    "УКАТЬ",
    "УКЛАД",
    "УКЛЕЯ",
    "УКЛОН",
    "УКОЛА",
    "УКОРА",
    "УКРОП",
    "УКРЮК",
    "УКСУС",
    "УЛАРЬ",
    "УЛАЧИ",
    "УЛЕВИ",
    "УЛЕГИ",
    "УЛЕДИ",
    "УЛИКА",
    "УЛИТА",
    "УЛИТЬ",
    "УЛИЦА",
    "УЛЮЛЯ",
    "УМБРА",
    "УМЕТЬ",
    "УМНИК",
    "УМНЫЙ",
    "УМОЛК",
    "УМОРА",
    "УМЫТЬ",
    "УМЯТЬ",
    "УНДАК",
    "УНДЕР",
    "УНЕГИ",
    "УНИНА",
    "УНИТА",
    "УНОША",
    "УНТЕР",
    "УНЦИЯ",
    "УНШИЙ",
    "УНЫТЬ",
    "УНЯТЬ",
    "УПАГИ",
    "УПАЧИ",
    "УПЕРЫ",
    "УПЕЧЬ",
    "УПИРЬ",
    "УПИТЬ",
    "УПОКИ",
    "УПРЁК",
    "УПРУГ",
    "УПЫРЬ",
    "УРАСА",
    "УРГУЙ",
    "УРЕМА",
    "УРЕНЬ",
    "УРЕЧЬ",
    "УРИНА",
    "УРЛАН",
    "УРМАН",
    "УРОМА",
    "УРУГА",
    "УРЮПА",
    "УРЯВА",
    "УСЕЧЬ",
    "УСИКИ",
    "УСКОК",
    "УСЛОН",
    "УСНИЕ",
    "УСПЕХ",
    "УСТАВ",
    "УСТОЙ",
    "УСТУП",
    "УСТЬЕ",
    "УТЕРЯ",
    "УТЕХА",
    "УТЕЧЬ",
    "УТИЛЬ",
    "УТИЦА",
    "УТЛЫЙ",
    "УТРОМ",
    "УТУГА",
    "УТЫТИ",
    "УХАРЬ",
    "УХАТЬ",
    "УХВАТ",
    "УЧАТЬ",
    "УЧЁБА",
    "УЧИТЬ",
    "УЧКУР",
    "УШИТЬ",
    "УШКАН",
    "УШКУЙ",
    "УШЛЫЙ",
    "УШНИК",
    "УШНОЕ",
    "УШНОЙ",
    "УЩЕРА",
    "УЩЕРБ",
    "ФАБРА",
    "ФАВНА",
    "ФАВОР",
    "ФАГОТ",
    "ФАЗАН",
    "ФАЗИС",
    "ФАЙКА",
    "ФАКЕЛ",
    "ФАКИР",
    "ФАЛДА",
    "ФАЛЕЦ",
    "ФАЛЬЦ",
    "ФАНАТ",
    "ФАНЗА",
    "ФАНТЫ",
    "ФАРБА",
    "ФАРЯБ",
    "ФАСАД",
    "ФАСКА",
    "ФАСОН",
    "ФАТЮЙ",
    "ФАУНА",
    "ФАЦЕТ",
    "ФАЯНС",
    "ФЕЛОН",
    "ФЕНИЛ",
    "ФЕНОЛ",
    "ФЕРЗЬ",
    "ФЕРМА",
    "ФЕСКА",
    "ФЕТИШ",
    "ФЕФЕР",
    "ФЕФКА",
    "ФИАКР",
    "ФИБРА",
    "ФИГЛЯ",
    "ФИГНЯ",
    "ФИЖМЫ",
    "ФИЗИК",
    "ФИКУС",
    "ФИЛЕЙ",
    "ФИЛЁР",
    "ФИЛИН",
    "ФИЛОН",
    "ФИЛЬМ",
    "ФИНАЛ",
    "ФИНИК",
    "ФИНИШ",
    "ФИНКА",
    "ФИННЫ",
    "ФИОЛЬ",
    "ФИОРД",
    "ФИРМА",
    "ФИФИК",
    "ФИШКА",
    "ФЛАНГ",
    "ФЛЕШЬ",
    "ФЛИРТ",
    "ФЛОКС",
    "ФЛОРА",
    "ФЛЮОР",
    "ФЛЯГА",
    "ФЛЯСТ",
    "ФОКУС",
    "ФОМКА",
    "ФОРМА",
    "ФОРМО",
    "ФОРТЕ",
    "ФОРУМ",
    "ФОСКА",
    "ФОФАН",
    "ФРАЗА",
    "ФРАНК",
    "ФРАНТ",
    "ФРАХТ",
    "ФРЕЗА",
    "ФРЕНЧ",
    "ФРИГА",
    "ФРОЛЫ",
    "ФРОНТ",
    "ФРУКТ",
    "ФРУНТ",
    "ФУГАС",
    "ФУЖЕР",
    "ФУЗЕЯ",
    "ФУЛЯР",
    "ФУРАЖ",
    "ФУРИЯ",
    "ФУРМА",
    "ФУРОР",
    "ФУТЕР",
    "ФУЭТЕ",
    "ФЬОРД",
    "ФЬЮТЬ",
    "ФЮРЕР",
    "ХАЙЛО",
    "ХАЙМА",
    "ХАЛАТ",
    "ХАЛВА",
    "ХАЛДА",
    "ХАЛИФ",
    "ХАЛУЙ",
    "ХАЛЫХ",
    "ХАМЗА",
    "ХАМЛО",
    "ХАМСА",
    "ХАМЬЁ",
    "ХАНЖА",
    "ХАНКА",
    "ХАНТЫ",
    "ХАПКА",
    "ХАРАЛ",
    "ХАРВА",
    "ХАРЕЙ",
    "ХАРЛО",
    "ХАРЧО",
    "ХАСИМ",
    "ХАШИШ",
    "ХАЯТЬ",
    "ХВАТЬ",
    "ХВИЛЯ",
    "ХВОРЬ",
    "ХВОСТ",
    "ХВОША",
    "ХЕРЕС",
    "ХИВОК",
    "ХИДКА",
    "ХИЛЫЙ",
    "ХИЛЯК",
    "ХИМИО",
    "ХИМИЯ",
    "ХИНДИ",
    "ХИНИН",
    "ХИППИ",
    "ХИРКА",
    "ХИТКА",
    "ХИТОН",
    "ХАБАР",
    "ХАДАК",
    "ХАИТА",
    "ХАЙКА",
    "ХАЙКО",
    "ХЛАДО",
    "ХЛЕБО",
    "ХЛЕСЦ",
    "ХЛУДА",
    "ХЛЫСТ",
    "ХЛЮСТ",
    "ХЛЯКИ",
    "ХМЕЛЬ",
    "ХМЫРЬ",
    "ХОББИ",
    "ХОБОТ",
    "ХОВРЯ",
    "ХОДЕЦ",
    "ХОДКА",
    "ХОДОК",
    "ХОИТЬ",
    "ХОЛОД",
    "ХОЛОП",
    "ХОЛСТ",
    "ХОЛУЙ",
    "ХОМУТ",
    "ХОМЯК",
    "ХОНГА",
    "ХОПЕР",
    "ХОРАЛ",
    "ХОРДА",
    "ХОРЕЙ",
    "ХОРЁК",
    "ХОРОМ",
    "ХОРУН",
    "ХОТОН",
    "ХОХЛЫ",
    "ХОХМА",
    "ХОХОЛ",
    "ХОХОТ",
    "ХРАНЦ",
    "ХРЕСТ",
    "ХРИЗА",
    "ХРОМО",
    "ХРОНО",
    "ХРУЛЬ",
    "ХРУНИ",
    "ХРУСТ",
    "ХРЯТЬ",
    "ХУБЛИ",
    "ХУДОЙ",
    "ХУДУК",
    "ХУНТА",
    "ХУПАН",
    "ХУРАЛ",
    "ХУРМА",
    "ХУРТА",
    "ХУРУЛ",
    "ХУСТА",
    "ХУТОР",
    "ХУТРА",
    "ХЫРЗЫ",
    "ЦАВЬЕ",
    "ЦАПКА",
    "ЦАПЛЯ",
    "ЦАРВА",
    "ЦАРЁК",
    "ЦВЁРА",
    "ЦВЕТО",
    "ЦВИЛЬ",
    "ЦЕВКА",
    "ЦЕВЬЁ",
    "ЦЕДРА",
    "ЦЕЗОН",
    "ЦЕЙКА",
    "ЦЕЛИК",
    "ЦЕЛЫЙ",
    "ЦЁЛЫШ",
    "ЦЕНТР",
    "ЦЕПКА",
    "ЦЕПЛЯ",
    "ЦЕРВА",
    "ЦЕРИЙ",
    "ЦЕТЕР",
    "ЦИБИК",
    "ЦИКЛЯ",
    "ЦИЛИК",
    "ЦИНГА",
    "ЦИНИК",
    "ЦИПЫШ",
    "ЦИРЕЛ",
    "ЦИРЕН",
    "ЦИРУС",
    "ЦИТРА",
    "ЦИФРА",
    "ЦМЫГА",
    "ЦУКАН",
    "ЦУКАТ",
    "ЦУРКА",
    "ЦУЦИК",
    "ЦЫБИК",
    "ЦЫБИС",
    "ЦЫВЦА",
    "ЦЫГАН",
    "ЦЫГУН",
    "ЦЫКЛЯ",
    "ЦЫПКА",
    "ЦЫПКИ",
    "ЦЫРЕН",
    "ЦЮМАК",
    "ЧАБАК",
    "ЧАБАН",
    "ЧАБАР",
    "ЧАБЕР",
    "ЧАБУН",
    "ЧАВКИ",
    "ЧАГАН",
    "ЧАГИР",
    "ЧАДРА",
    "ЧАЙКА",
    "ЧАКАН",
    "ЧАЛКА",
    "ЧАЛМА",
    "ЧАЛЫЙ",
    "ЧАМРА",
    "ЧАНЧА",
    "ЧАПАН",
    "ЧАРКА",
    "ЧАРКИ",
    "ЧАРОК",
    "ЧАРЫМ",
    "ЧАСОМ",
    "ЧАСТЬ",
    "ЧАХОЛ",
    "ЧАШКА",
    "ЧАЯТЬ",
    "ЧВИРЬ",
    "ЧЕБАК",
    "ЧЕБЕР",
    "ЧЕБОТ",
    "ЧЕДРА",
    "ЧЕКАН",
    "ЧЕКТА",
    "ЧЕЛЕК",
    "ЧЕЛИГ",
    "ЧЕЛИМ",
    "ЧЁЛКА",
    "ЧЕЛЫЙ",
    "ЧЕЛЫШ",
    "ЧЕМЕЗ",
    "ЧЕМЕР",
    "ЧЁМОР",
    "ЧЕМРА",
    "ЧЕМША",
    "ЧЕМЬЯ",
    "ЧЕПАН",
    "ЧЕПЕЦ",
    "ЧЕРВИ",
    "ЧЕРВЬ",
    "ЧЕРГА",
    "ЧЕРЁД",
    "ЧЕРЕЗ",
    "ЧЕРЕН",
    "ЧЕРЕП",
    "ЧЕРЕС",
    "ЧЕРЕТ",
    "ЧЕРИН",
    "ЧЕРКИ",
    "ЧЕРНО",
    "ЧЕРНЬ",
    "ЧЕРОК",
    "ЧЕРТА",
    "ЧЕРТИ",
    "ЧЕРЯЖ",
    "ЧЕСТИ",
    "ЧЕСТЬ",
    "ЧЕТИЙ",
    "ЧЕТКА",
    "ЧЁТКИ",
    "ЧЕТЦА",
    "ЧЕХОЛ",
    "ЧЕХОМ",
    "ЧЕХОР",
    "ЧЕЧЕТ",
    "ЧЕШКИ",
    "ЧЕШУЕ",
    "ЧЕШУЯ",
    "ЧИБАК",
    "ЧИБЕЗ",
    "ЧИБИС",
    "ЧИБЫК",
    "ЧИВЫЙ",
    "ЧИВЬЕ",
    "ЧИГАН",
    "ЧИГАС",
    "ЧИГИТ",
    "ЧИЖИК",
    "ЧИКАН",
    "ЧИЛИМ",
    "ЧИЛЯК",
    "ЧИНАК",
    "ЧИНАР",
    "ЧИПОР",
    "ЧИРЕЙ",
    "ЧИРЕЛ",
    "ЧИРКИ",
    "ЧИРОК",
    "ЧИРУЧ",
    "ЧИСЛО",
    "ЧИТКА",
    "ЧИТЫЙ",
    "ЧИХТА",
    "ЧИЧЕР",
    "ЧИШКА",
    "ЧМУКА",
    "ЧОБОТ",
    "ЧОЛКА",
    "ЧОМГА",
    "ЧОХОМ",
    "ЧРЕВО",
    "ЧРЕДА",
    "ЧРЕЗО",
    "ЧТИВО",
    "ЧТИТЬ",
    "ЧУБУК",
    "ЧУВАЛ",
    "ЧУГУН",
    "ЧУДАК",
    "ЧУДИК",
    "ЧУДОК",
    "ЧУДОМ",
    "ЧУЖАК",
    "ЧУЖОЙ",
    "ЧУЙКА",
    "ЧУЙНА",
    "ЧУКЧИ",
    "ЧУЛАН",
    "ЧУЛОК",
    "ЧУЛЫЙ",
    "ЧУМАК",
    "ЧУМАН",
    "ЧУМАШ",
    "ЧУНКИ",
    "ЧУПРА",
    "ЧУРАК",
    "ЧУРЕК",
    "ЧУРКА",
    "ЧУРЫМ",
    "ЧУТОК",
    "ЧУТЬЁ",
    "ЧУХНА",
    "ЧУШКА",
    "ЧУЯТЬ",
    "ЧХАТЬ",
    "ШАБАШ",
    "ШАБЁР",
    "ШАБУР",
    "ШАВКА",
    "ШАВОК",
    "ШАГЛА",
    "ШАГОМ",
    "ШАДРА",
    "ШАИКТ",
    "ШАИТЬ",
    "ШАЙБА",
    "ШАЙГА",
    "ШАЙКА",
    "ШАКАЛ",
    "ШАКША",
    "ШАЛАШ",
    "ШАЛГА",
    "ШАЛОН",
    "ШАЛУН",
    "ШАЛЫЙ",
    "ШАМАН",
    "ШАМАЯ",
    "ШАМОК",
    "ШАМОТ",
    "ШАМРА",
    "ШАНГА",
    "ШАНЕЦ",
    "ШАПАР",
    "ШАПКА",
    "ШАПША",
    "ШАРАН",
    "ШАРАП",
    "ШАРАХ",
    "ШАРГА",
    "ШАРДА",
    "ШАРЕЙ",
    "ШАРИК",
    "ШАРКА",
    "ШАРОК",
    "ШАРОМ",
    "ШАССИ",
    "ШАСТЬ",
    "ШАТЕН",
    "ШАТЁР",
    "ШАТИЯ",
    "ШАФЕР",
    "ШАХМА",
    "ШАХОР",
    "ШАХТА",
    "ШАШАЛ",
    "ШАШКА",
    "ШАШКИ",
    "ШАШНИ",
    "ШАЯТЬ",
    "ШВАЛЬ",
    "ШВЕДЫ",
    "ШЕБЁЛ",
    "ШЕБЕР",
    "ШЕВЕЦ",
    "ШЕВРО",
    "ШЕГЛА",
    "ШЕГНЯ",
    "ШЕЙКА",
    "ШЕЙМА",
    "ШЕЛЕГ",
    "ШЕЛЕП",
    "ШЕЛОМ",
    "ШЕЛЬФ",
    "ШЕЛЯГ",
    "ШЕМАЯ",
    "ШЁПОТ",
    "ШЕПША",
    "ШЕРБА",
    "ШЕРИФ",
    "ШЕРОХ",
    "ШЕРПА",
    "ШЕРПЫ",
    "ШЕРТЬ",
    "ШЕСТИ",
    "ШЕСТЬ",
    "ШЕШОК",
    "ШИБКА",
    "ШИГДА",
    "ШИЗИК",
    "ШИКША",
    "ШИЛЬЯ",
    "ШИНОК",
    "ШИПУН",
    "ШИРМА",
    "ШИРОМ",
    "ШИТЫЙ",
    "ШИТЬЁ",
    "ШИФЕР",
    "ШИФОН",
    "ШИХАН",
    "ШИХТА",
    "ШИШАК",
    "ШИШКА",
    "ШКАЛА",
    "ШКАЛИ",
    "ШКАПА",
    "ШКВАЛ",
    "ШКЕРЫ",
    "ШКИЛЬ",
    "ШКИРЬ",
    "ШКЛЯК",
    "ШКОДА",
    "ШКОЛА",
    "ШКОНТ",
    "ШКУЛЬ",
    "ШКУНА",
    "ШКУРА",
    "ШЛАНГ",
    "ШЛЕЙФ",
    "ШЛЮХА",
    "ШЛЯПА",
    "ШЛЯЧА",
    "ШМАРА",
    "ШМЕЛЬ",
    "ШМЕРЦ",
    "ШМУКА",
    "ШНЕКА",
    "ШНЯВА",
    "ШНЯКА",
    "ШОБОЛ",
    "ШОГЛА",
    "ШОГРА",
    "ШОЙДА",
    "ШОЛГА",
    "ШОЛОМ",
    "ШОРНЯ",
    "ШОРОХ",
    "ШОРТЫ",
    "ШОССЕ",
    "ШОФЁР",
    "ШОХРА",
    "ШПАГА",
    "ШПАЛА",
    "ШПАНА",
    "ШПАТЫ",
    "ШПЕНТ",
    "ШПЕНЬ",
    "ШПИЛЬ",
    "ШПИНЬ",
    "ШПИОН",
    "ШПОРА",
    "ШПРИЦ",
    "ШПУЛЯ",
    "ШПУНТ",
    "ШРАГА",
    "ШРИФТ",
    "ШТАМБ",
    "ШТАМП",
    "ШТАНЫ",
    "ШТЕЙН",
    "ШТЕРТ",
    "ШТИЛЬ",
    "ШТИФТ",
    "ШТОРА",
    "ШТОРМ",
    "ШТРАБ",
    "ШТРАФ",
    "ШТРЕК",
    "ШТРИХ",
    "ШТУКА",
    "ШТУРМ",
    "ШТЫРЬ",
    "ШУВАР",
    "ШУГАЙ",
    "ШУЙЦА",
    "ШУЛЕР",
    "ШУЛИК",
    "ШУМОК",
    "ШУПЕЛ",
    "ШУРГА",
    "ШУРИН",
    "ШУРКА",
    "ШУРУП",
    "ШУСТА",
    "ШУТЕМ",
    "ШУТКА",
    "ШУТЫЙ",
    "ШУШУН",
    "ШХЕРЫ",
    "ШХОУТ",
    "ШХУНА",
    "ЩАБЁР",
    "ЩАВЫЙ",
    "ЩАДРА",
    "ЩАНОЙ",
    "ЩЕБРА",
    "ЩЕГЛА",
    "ЩЕГОЛ",
    "ЩЕДРА",
    "ЩЁКОТ",
    "ЩЕКУН",
    "ЩЕЛЕП",
    "ЩЁЛКА",
    "ЩЁЛОК",
    "ЩЕНОК",
    "ЩЕПКА",
    "ЩЕРБА",
    "ЩЁТКА",
    "ЩЁЧКА",
    "ЩИПОК",
    "ЩИПЦЫ",
    "ЩИРЫЙ",
    "ЩИТОК",
    "ЩОГЛА",
    "ЩОКУР",
    "ЩОРБА",
    "ЩУЛЕП",
    "ЩУРУП",
    "ЩУЧИЙ",
    "ЭВАКО",
    "ЭВЕНЫ",
    "ЭВЛАС",
    "ЭГИДА",
    "ЭГИРА",
    "ЭКЛЕР",
    "ЭКРАН",
    "ЭКСТА",
    "ЭЛИПС",
    "ЭЛИТА",
    "ЭМАЛЬ",
    "ЭННЫЙ",
    "ЭНТОТ",
    "ЭПОХА",
    "ЭРЗАЦ",
    "ЭРКЕР",
    "ЭСКИЗ",
    "ЭСТЕТ",
    "ЭТИКА",
    "ЭТНОС",
    "ЭТЮДЫ",
    "ЭФЕКТ",
    "ЮЛИТЬ",
    "ЮРИСТ",
    "ЮФЕРС",
    "ЮРКИЙ",
    "ЮЖИКА",
    "ЮТИТЬ",
    "ЮННАТ",
    "ЮДОЛЬ",
    "ЮМШАН",
    "ЮШМАН",
    "ЯБАГА",
    "ЯБЕДА",
    "ЯБУРЬ",
    "ЯВИДЬ",
    "ЯВИТЬ",
    "ЯВНЫЙ",
    "ЯГАТЬ",
    "ЯГЕЛЬ",
    "ЯГОДА",
    "ЯГУАР",
    "ЯЗАТЬ",
    "ЯИЧКО",
    "ЯКАТЬ",
    "ЯКОБЫ",
    "ЯКОРЬ",
    "ЯКУТЫ",
    "ЯКУША",
    "ЯЛАНЬ",
    "ЯЛАПА",
    "ЯМЕГА",
    "ЯМИНА",
    "ЯМЧУГ",
    "ЯМЩИК",
    "ЯНЧАЛ",
    "ЯНЫСЬ",
    "ЯНЬКА",
    "ЯРГАК",
    "ЯРИТЬ",
    "ЯРКИЙ",
    "ЯРЛЫК",
    "ЯРМЯК",
    "ЯРЫГА",
    "ЯРЫЦЫ",
    "ЯСАТЬ",
    "ЯСАУЛ",
    "ЯСЕНЬ",
    "ЯСЛЯК",
    "ЯСМИН",
    "ЯСНЫЙ",
    "ЯСПИС",
    "ЯСТВО",
    "ЯСТЫК",
    "ЯТНЫЙ",
    "ЯХОНТ",
    "ЯХТАШ",
    "ЯЧАТЬ"
]
